import { useState, useEffect, useCallback, useRef } from "react";
import { useParams, Link } from "react-router-dom";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Table from 'react-bootstrap/Table';
import Dropdown from 'react-bootstrap/Dropdown';
import Spinner from 'react-bootstrap/Spinner';
import Modal from 'react-bootstrap/Modal';
import Alert from 'react-bootstrap/Alert';
import { ventrisConfig } from '../../ventris.config';
import { useAbly } from "../../realtime/useAbly";
import PronunciationGuidance from "../../components/PronunciationGuidance";
import WraAudioStatus, { WraAudioState } from "../../components/WraAudioStatus";

import WraAudioPlayingIcon from '../../icons/WraAudioPlayingIcon';
import WraAudioStoppedIcon from '../../icons/WraAudioStoppedIcon';
import WraWordIcon from '../../icons/WraWordIcon';

import logo from '../../assets/img/logo.jpg';
import logoGrey from '../../assets/img/logo-grey.png';
import wra from '../../assets/img/wra.png';

type TestWRAProps = {
  role: string
};

const showWraProgressBars = false;

const initialQuestions: any = [
  {
    "Grade": "K",
    "Season": "Fall",
    "Question": 1,
    "Label": "Fall K mean - 0.5 SD",
    "BLE": -1.012556717,
    "DEL": -1.813762789,
    "WRE": "",
    "NWE": ""
  },
  {
    "Grade": "K",
    "Season": "Fall",
    "Question": 2,
    "Label": "Fall K mean - 0.25 SD",
    "BLE": -0.679978732,
    "DEL": -1.508453604,
    "WRE": "",
    "NWE": ""
  },
  {
    "Grade": "K",
    "Season": "Fall",
    "Question": 3,
    "Label": "Fall K mean theta",
    "BLE": -0.347400748,
    "DEL": -1.203144418,
    "WRE": "",
    "NWE": ""
  },
  {
    "Grade": "K",
    "Season": "Fall",
    "Question": 4,
    "Label": "Fall K mean + 0.25 SD",
    "BLE": -0.014822763,
    "DEL": -0.897835233,
    "WRE": "",
    "NWE": ""
  },
  {
    "Grade": "K",
    "Season": "Fall",
    "Question": 5,
    "Label": "Fall K mean + 0.5 SD",
    "BLE": 0.317755221,
    "DEL": -0.592526047,
    "WRE": "",
    "NWE": ""
  },
  {
    "Grade": "K",
    "Season": "Winter",
    "Question": 1,
    "Label": "Winter K mean - 1SD",
    "BLE": -1.090934588,
    "DEL": -2.180702584,
    "WRE": -1.701648209,
    "NWE": -1.298402822
  },
  {
    "Grade": "K",
    "Season": "Winter",
    "Question": 2,
    "Label": "Winter K mean - 0.5 SD",
    "BLE": -0.476593105,
    "DEL": -1.556328016,
    "WRE": -1.322164986,
    "NWE": -0.964648831
  },
  {
    "Grade": "K",
    "Season": "Winter",
    "Question": 3,
    "Label": "Winter K mean theta",
    "BLE": 0.137748378,
    "DEL": -0.931953449,
    "WRE": -0.942681763,
    "NWE": -0.63089484
  },
  {
    "Grade": "K",
    "Season": "Winter",
    "Question": 4,
    "Label": "Winter K mean + 0.5 SD",
    "BLE": 0.75208986,
    "DEL": -0.307578881,
    "WRE": -0.56319854,
    "NWE": -0.297140849
  },
  {
    "Grade": "K",
    "Season": "Winter",
    "Question": 5,
    "Label": "Winter K mean + 1SD",
    "BLE": 1.366431343,
    "DEL": 0.316795686,
    "WRE": -0.183715317,
    "NWE": 0.036613141
  },
  {
    "Grade": "K",
    "Season": "Spring",
    "Question": 1,
    "Label": "Spring K mean - 1SD",
    "BLE": -0.519349724,
    "DEL": -1.805662426,
    "WRE": -1.376547207,
    "NWE": -1.134027618
  },
  {
    "Grade": "K",
    "Season": "Spring",
    "Question": 2,
    "Label": "Spring K mean - 0.5 SD",
    "BLE": -0.010533927,
    "DEL": -1.211173399,
    "WRE": -1.010480788,
    "NWE": -0.760835305
  },
  {
    "Grade": "K",
    "Season": "Spring",
    "Question": 3,
    "Label": "Spring K mean theta",
    "BLE": 0.49828187,
    "DEL": -0.616684372,
    "WRE": -0.644414369,
    "NWE": -0.387642993
  },
  {
    "Grade": "K",
    "Season": "Spring",
    "Question": 4,
    "Label": "Spring K mean + 0.5 SD",
    "BLE": 1.007097667,
    "DEL": -0.022195345,
    "WRE": -0.27834795,
    "NWE": -0.014450681
  },
  {
    "Grade": "K",
    "Season": "Spring",
    "Question": 5,
    "Label": "Spring K mean + 1SD",
    "BLE": 1.515913464,
    "DEL": 0.572293682,
    "WRE": 0.087718469,
    "NWE": 0.358741632
  },
  {
    "Grade": "1st",
    "Season": "Fall",
    "Question": 1,
    "Label": "Fall 1st mean - 1SD",
    "BLE": "",
    "DEL": -1.537742335,
    "WRE": -1.048269259,
    "NWE": -0.952087067
  },
  {
    "Grade": "1st",
    "Season": "Fall",
    "Question": 2,
    "Label": "Fall 1st mean - 0.5 SD",
    "BLE": "",
    "DEL": -0.970321599,
    "WRE": -0.66528334,
    "NWE": -0.569918661
  },
  {
    "Grade": "1st",
    "Season": "Fall",
    "Question": 3,
    "Label": "Fall 1st mean theta",
    "BLE": "",
    "DEL": -0.402900862,
    "WRE": -0.282297421,
    "NWE": -0.187750255
  },
  {
    "Grade": "1st",
    "Season": "Fall",
    "Question": 4,
    "Label": "Fall 1st mean + 0.5 SD",
    "BLE": "",
    "DEL": 0.164519874,
    "WRE": 0.100688498,
    "NWE": 0.194418151
  },
  {
    "Grade": "1st",
    "Season": "Fall",
    "Question": 5,
    "Label": "Fall 1st mean + 1SD",
    "BLE": "",
    "DEL": 0.731940611,
    "WRE": 0.483674416,
    "NWE": 0.576586557
  },
  {
    "Grade": "1st",
    "Season": "Winter",
    "Question": 1,
    "Label": "Winter 1st mean - 1SD",
    "BLE": "",
    "DEL": -1.232841607,
    "WRE": -0.66983526,
    "NWE": -0.734189526
  },
  {
    "Grade": "1st",
    "Season": "Winter",
    "Question": 2,
    "Label": "Winter 1st mean - 0.5 SD",
    "BLE": "",
    "DEL": -0.688884874,
    "WRE": -0.315448193,
    "NWE": -0.355375756
  },
  {
    "Grade": "1st",
    "Season": "Winter",
    "Question": 3,
    "Label": "Winter 1st mean theta",
    "BLE": "",
    "DEL": -0.144928141,
    "WRE": 0.038938873,
    "NWE": 0.023438013
  },
  {
    "Grade": "1st",
    "Season": "Winter",
    "Question": 4,
    "Label": "Winter 1st mean + 0.5 SD",
    "BLE": "",
    "DEL": 0.399028592,
    "WRE": 0.393325939,
    "NWE": 0.402251782
  },
  {
    "Grade": "1st",
    "Season": "Winter",
    "Question": 5,
    "Label": "Winter 1st mean + 1SD",
    "BLE": "",
    "DEL": 0.942985325,
    "WRE": 0.747713005,
    "NWE": 0.781065552
  },
  {
    "Grade": "1st",
    "Season": "Spring",
    "Question": 1,
    "Label": "Spring 1st mean - 1SD",
    "BLE": "",
    "DEL": -0.944656303,
    "WRE": -0.28651305,
    "NWE": -0.417059588
  },
  {
    "Grade": "1st",
    "Season": "Spring",
    "Question": 2,
    "Label": "Spring 1st mean - 0.5 SD",
    "BLE": "",
    "DEL": -0.421402426,
    "WRE": 0.047295469,
    "NWE": -0.08062475
  },
  {
    "Grade": "1st",
    "Season": "Spring",
    "Question": 3,
    "Label": "Spring 1st mean theta",
    "BLE": "",
    "DEL": 0.101851451,
    "WRE": 0.381103987,
    "NWE": 0.255810087
  },
  {
    "Grade": "1st",
    "Season": "Spring",
    "Question": 4,
    "Label": "Spring 1st mean + 0.5 SD",
    "BLE": "",
    "DEL": 0.625105329,
    "WRE": 0.714912506,
    "NWE": 0.592244925
  },
  {
    "Grade": "1st",
    "Season": "Spring",
    "Question": 5,
    "Label": "Spring 1st mean + 1SD",
    "BLE": "",
    "DEL": 1.148359206,
    "WRE": 1.048721024,
    "NWE": 0.928679762
  },
  {
    "Grade": "2nd",
    "Season": "Fall",
    "Question": 1,
    "Label": "Fall 2nd mean - 1SD",
    "BLE": "",
    "DEL": -0.830245455,
    "WRE": 0.068402849,
    "NWE": -0.359866103
  },
  {
    "Grade": "2nd",
    "Season": "Fall",
    "Question": 2,
    "Label": "Fall 2nd mean - 0.5 SD",
    "BLE": "",
    "DEL": -0.266011545,
    "WRE": 0.384350084,
    "NWE": 0.028504568
  },
  {
    "Grade": "2nd",
    "Season": "Fall",
    "Question": 3,
    "Label": "Fall 2nd mean theta",
    "BLE": "",
    "DEL": 0.298222365,
    "WRE": 0.700297318,
    "NWE": 0.41687524
  },
  {
    "Grade": "2nd",
    "Season": "Fall",
    "Question": 4,
    "Label": "Fall 2nd mean + 0.5 SD",
    "BLE": "",
    "DEL": 0.862456275,
    "WRE": 1.016244553,
    "NWE": 0.805245912
  },
  {
    "Grade": "2nd",
    "Season": "Fall",
    "Question": 5,
    "Label": "Fall 2nd mean + 1SD",
    "BLE": "",
    "DEL": 1.426690186,
    "WRE": 1.332191787,
    "NWE": 1.193616583
  },
  {
    "Grade": "2nd",
    "Season": "Winter",
    "Question": 1,
    "Label": "Winter 2nd mean - 1SD",
    "BLE": "",
    "DEL": -0.661647047,
    "WRE": 0.318756667,
    "NWE": -0.01255715
  },
  {
    "Grade": "2nd",
    "Season": "Winter",
    "Question": 2,
    "Label": "Winter 2nd mean - 0.5 SD",
    "BLE": "",
    "DEL": -0.070229117,
    "WRE": 0.689634469,
    "NWE": 0.321762968
  },
  {
    "Grade": "2nd",
    "Season": "Winter",
    "Question": 3,
    "Label": "Winter 2nd mean theta",
    "BLE": "",
    "DEL": 0.521188813,
    "WRE": 1.06051227,
    "NWE": 0.656083085
  },
  {
    "Grade": "2nd",
    "Season": "Winter",
    "Question": 4,
    "Label": "Winter 2nd mean + 0.5 SD",
    "BLE": "",
    "DEL": 1.112606744,
    "WRE": 1.431390072,
    "NWE": 0.990403202
  },
  {
    "Grade": "2nd",
    "Season": "Winter",
    "Question": 5,
    "Label": "Winter 2nd mean + 1SD",
    "BLE": "",
    "DEL": 1.704024674,
    "WRE": 1.802267874,
    "NWE": 1.324723319
  },
  {
    "Grade": "2nd",
    "Season": "Spring",
    "Question": 1,
    "Label": "Spring 2nd mean - 1SD",
    "BLE": "",
    "DEL": -0.376436531,
    "WRE": 0.569182369,
    "NWE": 0.059104366
  },
  {
    "Grade": "2nd",
    "Season": "Spring",
    "Question": 2,
    "Label": "Spring 2nd mean - 0.5 SD",
    "BLE": "",
    "DEL": 0.206798327,
    "WRE": 0.96489381,
    "NWE": 0.461571838
  },
  {
    "Grade": "2nd",
    "Season": "Spring",
    "Question": 3,
    "Label": "Spring 2nd mean theta",
    "BLE": "",
    "DEL": 0.790033186,
    "WRE": 1.36060525,
    "NWE": 0.864039309
  },
  {
    "Grade": "2nd",
    "Season": "Spring",
    "Question": 4,
    "Label": "Spring 2nd mean + 0.5 SD",
    "BLE": "",
    "DEL": 1.373268045,
    "WRE": 1.75631669,
    "NWE": 1.266506781
  },
  {
    "Grade": "2nd",
    "Season": "Spring",
    "Question": 5,
    "Label": "Spring 2nd mean + 1SD",
    "BLE": "",
    "DEL": 1.956502904,
    "WRE": 2.152028131,
    "NWE": 1.668974252
  },
  {
    "Grade": "3rd",
    "Season": "Fall",
    "Question": 1,
    "Label": "Fall 3rd mean - 1SD",
    "BLE": "",
    "DEL": "",
    "WRE": 0.887427006,
    "NWE": 0.145048608
  },
  {
    "Grade": "3rd",
    "Season": "Fall",
    "Question": 2,
    "Label": "Fall 3rd mean - 0.5 SD",
    "BLE": "",
    "DEL": "",
    "WRE": 1.288538937,
    "NWE": 0.616652572
  },
  {
    "Grade": "3rd",
    "Season": "Fall",
    "Question": 3,
    "Label": "Fall 3rd mean theta",
    "BLE": "",
    "DEL": "",
    "WRE": 1.689650867,
    "NWE": 1.088256535
  },
  {
    "Grade": "3rd",
    "Season": "Fall",
    "Question": 4,
    "Label": "Fall 3rd mean + 0.5 SD",
    "BLE": "",
    "DEL": "",
    "WRE": 2.090762798,
    "NWE": 1.559860499
  },
  {
    "Grade": "3rd",
    "Season": "Fall",
    "Question": 5,
    "Label": "Fall 3rd mean + 1SD",
    "BLE": "",
    "DEL": "",
    "WRE": 2.491874728,
    "NWE": 2.031464463
  },
  {
    "Grade": "3rd",
    "Season": "Winter",
    "Question": 1,
    "Label": "Winter 3rd mean - 1SD",
    "BLE": "",
    "DEL": "",
    "WRE": 1.318953042,
    "NWE": 0.450090767
  },
  {
    "Grade": "3rd",
    "Season": "Winter",
    "Question": 2,
    "Label": "Winter 3rd mean - 0.5 SD",
    "BLE": "",
    "DEL": "",
    "WRE": 1.684419341,
    "NWE": 0.858605612
  },
  {
    "Grade": "3rd",
    "Season": "Winter",
    "Question": 3,
    "Label": "Winter 3rd mean theta",
    "BLE": "",
    "DEL": "",
    "WRE": 2.04988564,
    "NWE": 1.267120456
  },
  {
    "Grade": "3rd",
    "Season": "Winter",
    "Question": 4,
    "Label": "Winter 3rd mean + 0.5 SD",
    "BLE": "",
    "DEL": "",
    "WRE": 2.415351939,
    "NWE": 1.675635301
  },
  {
    "Grade": "3rd",
    "Season": "Winter",
    "Question": 5,
    "Label": "Winter 3rd mean + 1SD",
    "BLE": "",
    "DEL": "",
    "WRE": 2.780818237,
    "NWE": 2.084150145
  },
  {
    "Grade": "3rd",
    "Season": "Spring",
    "Question": 1,
    "Label": "Spring 3rd mean - 1SD",
    "BLE": "",
    "DEL": "",
    "WRE": 1.592259224,
    "NWE": 0.742119993
  },
  {
    "Grade": "3rd",
    "Season": "Spring",
    "Question": 2,
    "Label": "Spring 3rd mean - 0.5 SD",
    "BLE": "",
    "DEL": "",
    "WRE": 1.980044028,
    "NWE": 1.117059693
  },
  {
    "Grade": "3rd",
    "Season": "Spring",
    "Question": 3,
    "Label": "Spring 3rd mean theta",
    "BLE": "",
    "DEL": "",
    "WRE": 2.367828833,
    "NWE": 1.491999394
  },
  {
    "Grade": "3rd",
    "Season": "Spring",
    "Question": 4,
    "Label": "Spring 3rd mean + 0.5 SD",
    "BLE": "",
    "DEL": "",
    "WRE": 2.755613637,
    "NWE": 1.866939094
  },
  {
    "Grade": "3rd",
    "Season": "Spring",
    "Question": 5,
    "Label": "Spring 3rd mean + 1SD",
    "BLE": "",
    "DEL": "",
    "WRE": 3.143398442,
    "NWE": 2.241878795
  }
];

let audioContext: any;
let audioBuffer: any;

function TestWRA({role}: TestWRAProps) {
  const routeParams = useParams();
  const [test, setTest] = useState({} as any);
  const [schemas, setSchemas] = useState([] as any);
  const [schema, setSchema] = useState({} as any);
  const [categories, setCategories] = useState([] as any);
  const [answers, setAnswers] = useState({} as any);
  const [textAnswers, setTextAnswers] = useState({} as any);
  const [numericAnswers, setNumericAnswers] = useState({} as any);
  const [correctAnswers, setCorrectAnswers] = useState(0 as any);
  const [incorrectAnswers, setIncorrectAnswers] = useState(0 as any);
  const [blankAnswers, setBlankAnswers] = useState(0 as any);
  const [cardKey, setCardKey] = useState("" as any);
  const [domains, setDomains] = useState({} as any);
  const [selectedSubtest, setSelectedSubtest] = useState(null as any);
  const [mode, setMode] = useState("Prompt" as any);
  const [subtestScores, setSubtestScores] = useState([] as any);
  const [testAdministrationDate, setTestAdministrationDate] = useState(null as any);

  const [studentName, setStudentName] = useState("" as any);
  const [studentGrade, setStudentGrade] = useState("" as any);
  const [season, setSeason] = useState("" as any);
  const [scores, setScores] = useState({} as any);

  const [currentQuestionStep, setCurrentQuestionStep] = useState(1 as any);
  const [currentQuestionCorrect, setCurrentQuestionCorrect] = useState(null as any);
  const [shownSubtestSelection, setShownSubtestSelection] = useState(false as any);
  const [selectedSubtests, setSelectedSubtests] = useState([] as any);
  const [shownInstructionsForSubtest, setShownInstructionsForSubtest] = useState(false as any);
  const [playedInstructionCount, setPlayedInstructionCount] = useState(0 as any);
  const [shownExamplesForSubtest, setShownExamplesForSubtest] = useState(false as any);
  const [shownExampleCount, setShownExampleCount] = useState(0 as any);
  const [allowedAudio, setAllowedAudio] = useState(false as any);
  const [audioPlaying, setAudioPlaying] = useState(false as any);
  const [audioState, setAudioState] = useState<WraAudioState>('idle');
  const [audioStatusMessage, setAudioStatusMessage] = useState('');
  const [reorderingQuestions, setReorderingQuestions] = useState(false as any);
  const [showBeginSubtestButton, setShowBeginSubtestButton] = useState(false as any);
  const [showFloorCeilingModal, setShowFloorCeilingModal] = useState(false as any);
  const [debugMode, setDebugMode] = useState(false);
  const [selectedDebugQuestionId, setSelectedDebugQuestionId] = useState<number | null>(null);
  const [currentUser, setCurrentUser] = useState<any | null>(null);
  const [studentRealtimeStatus, setStudentRealtimeStatus] = useState<"waiting" | "connected" | "ready">("waiting");
  const studentChannelRef = useRef<any>(null);
  const studentRealtimeReady = studentRealtimeStatus === "ready";

  const { ably, status } = useAbly(routeParams.testId);
  const [current, setCurrent] = useState<any | null>(null);
  const [currentImage, setCurrentImage] = useState<any | null>(null);
  const [studentTestCompleted, setStudentTestCompleted] = useState(false);
  const [studentTestCancelled, setStudentTestCancelled] = useState(false);
  const realtimeChannelUserId = test?.user_id;

  const normalizeGrade = (grade: string) => {
    if (!grade) {
      return grade;
    }

    const normalized = String(grade).trim().toLowerCase();
    if (normalized === "k" || normalized.includes("kindergarten")) {
      return "K";
    }
    if (normalized.includes("first")) {
      return "1st";
    }
    if (normalized.includes("second")) {
      return "2nd";
    }
    if (normalized.includes("third")) {
      return "3rd";
    }

    const numericMatch = normalized.match(/\d+/);
    if (numericMatch) {
      const numericGrade = parseInt(numericMatch[0], 10);
      if (numericGrade === 1) {
        return "1st";
      }
      if (numericGrade === 2) {
        return "2nd";
      }
      if (numericGrade === 3) {
        return "3rd";
      }
      if (numericGrade >= 4) {
        return "3rd";
      }
    }

    return grade;
  };
  
  useEffect(() => {
    let token = sessionStorage.getItem("token");
    fetch(ventrisConfig.url + '/api/schemas', {
      method: 'get',
      headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
      }
    }).then(function (response) {
      return response.json();
    }).then(async function (data) {
      setSchemas(data);

      for (let i = 0; i < data?.length; i++) {
        if (data[i].name == 'WRA') {
          setSchema(data[i]);
          
          let rawQuestions: any = data[i].questions;
          let groupedCategories: any = [];

          for (let j = 0; j < data[i].questions?.length; j++) {
            let categoryIndex: number = -1;
            for (let k = 0; k < groupedCategories.length; k++) {
              if (groupedCategories[k].name == data[i].questions[j].category) {
                categoryIndex = k;
                break;
              }
            }

            if (categoryIndex == -1) {
              categoryIndex = groupedCategories.length;
              groupedCategories.push({
                name: data[i].questions[j].category,
                subcategories: []
              });
            }

            let subcategoryIndex: number = -1;
            for (let k = 0; k < groupedCategories[categoryIndex].subcategories.length; k++) {
              if (groupedCategories[categoryIndex].subcategories[k].name == data[i].questions[j].subcategory) {
                subcategoryIndex = k;
                break;
              }
            }

            if (subcategoryIndex == -1) {
              subcategoryIndex = groupedCategories[categoryIndex].subcategories.length;
              groupedCategories[categoryIndex].subcategories.push({
                name: data[i].questions[j].subcategory,
                questions: [],
                questionsUnfiltered: []
              });
            }

            if (data[i].questions[j].discrimination && data[i].questions[j].difficulty) {
              groupedCategories[categoryIndex].subcategories[subcategoryIndex].questions.push(data[i].questions[j]);
              groupedCategories[categoryIndex].subcategories[subcategoryIndex].questionsUnfiltered.push(data[i].questions[j]);
            }
          }

          setCategories(groupedCategories);

          fetch(ventrisConfig.url + '/api/test/' + routeParams.testId, {
            method: 'get',
            headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token
            }
          }).then(function (response) {
            return response.json();
          }).then(async function (data) {
            let answersUpdated: any = {};
            let textAnswersUpdated: any = {};
            let numericAnswersUpdated: any = {};
            let correctAnswersUpdated = 0;
            let incorrectAnswersUpdated = 0;
            let blankAnswersUpdated = 0;
            let domainsUpdated: any = {};

            for (let j = 0; j < groupedCategories.length; j++) {
              for (let k = 0; k < groupedCategories[j].subcategories?.length; k++) {
                groupedCategories[j].subcategories[k].questions = [];
                for (let l = 0; l < groupedCategories[j].subcategories[k].questionsUnfiltered?.length; l++) {
                  if (!data.test?.used_questions?.includes(groupedCategories[j].subcategories[k].questionsUnfiltered[l].id)) {
                    groupedCategories[j].subcategories[k].questions.push(groupedCategories[j].subcategories[k].questionsUnfiltered[l]);
                  } else {
                    console.log("Filtered Out Question: " + groupedCategories[j].subcategories[k].questionsUnfiltered[l].id);
                  }
                }
              }
            }

            setCategories(groupedCategories);
            
            for (let i = 0; i < data.test?.answers?.length; i++) {
              answersUpdated[data.test.answers[i].test_schema_question_id] = data.test.answers[i].test_schema_question_answer_id;
              textAnswersUpdated[data.test.answers[i].test_schema_question_id] = data.test.answers[i].text_answer;
              numericAnswersUpdated[data.test.answers[i].test_schema_question_id] = data.test.answers[i].numeric_answer;
              if (!domainsUpdated[data.test.answers[i].question?.category]) {
                domainsUpdated[data.test.answers[i].question?.category] = {
                  domain: data.test.answers[i].question?.category,
                  score: 0
                }
              }

              if (data.test.answers[i].test_schema_question_answer_id == 0 && data.test.answers[i].question?.answers?.length == 0) {
                let score = parseInt(data.test.answers[i].numeric_answer);
                if (!isNaN(score)) {
                  domainsUpdated[data.test.answers[i].question?.category].score += score;
                }
              }

              for (let j = 0; j < rawQuestions?.length; j++) {
                if (data.test.answers[i].test_schema_question_id == rawQuestions[j].id) {
                  for (let k = 0; k < rawQuestions[j].answers?.length; k++) {
                    if (rawQuestions[j].answers[k].id == data.test.answers[i].test_schema_question_answer_id) {
                      if (rawQuestions[j].answers[k].correct == 1) {
                        correctAnswersUpdated++;
                      } else {
                        incorrectAnswersUpdated++;
                      }
                      domainsUpdated[data.test.answers[i].question?.category].score += rawQuestions[j].answers[k].score;
                    }
                  }
                }
              }
            }

            blankAnswersUpdated = rawQuestions.length - correctAnswersUpdated - incorrectAnswersUpdated;

            setAnswers(answersUpdated);
            setTextAnswers(textAnswersUpdated);
            setNumericAnswers(numericAnswersUpdated);
            setCorrectAnswers(correctAnswersUpdated);
            setIncorrectAnswers(incorrectAnswersUpdated);
            setBlankAnswers(blankAnswersUpdated);
            setDomains(domainsUpdated);
            setStudentName(data.test.student.last_name + ", " + data.test.student.first_name);
            setStudentGrade(data.test.student.grade);
            setSubtestScores(data.test.subtest_scores ?? []);
            setMode(data.test.prompt_mode ? "Prompt" : "Record Form");
            if (data.test.season) {
              setSeason(data.test.season);
            } else {
              data.test.season = "Fall";
              setSeason("Fall");
            }
            if (data.test.completed_timestamp) {
              setTestAdministrationDate(data.test.completed_timestamp);
            } else {
              const now = new Date();
              const pad = (n: number) => String(n).padStart(2, "0");
              const formatted = [
                now.getFullYear(),
                pad(now.getMonth() + 1),
                pad(now.getDate())
              ].join("-") + " 00:00:00";
              data.test.completed_timestamp = formatted;
              setTestAdministrationDate(formatted);
            }
            setTest(data.test);

            const initialSelectedSubtests: any = data.test.selected_subtests ? data.test.selected_subtests.split("|") : [];

            if (initialSelectedSubtests.length > 0) {
              setSelectedSubtests(initialSelectedSubtests);
              if (data.test.season && data.test.completed_timestamp) {
                setShownSubtestSelection(true);
                const initialScores = computeScores(groupedCategories, answersUpdated);
                launchInitialSubtest(data.test, answersUpdated, groupedCategories, initialScores, initialSelectedSubtests, normalizeGrade(data.test.student.grade), data.test.season);
              }
            } else {
              const normalizedGrade = normalizeGrade(data.test.student.grade);
              let updatedSelectedSubtests: any = [];
              for (let i = 0; i < initialQuestions.length; i++) {
                if (initialQuestions[i].Grade == normalizedGrade && initialQuestions[i].Season == data.test.season && initialQuestions[i]['BLE'] != "" && !updatedSelectedSubtests.includes("Blending")) {
                  updatedSelectedSubtests.push("Blending");
                } else if (initialQuestions[i].Grade == normalizedGrade && initialQuestions[i].Season == data.test.season && initialQuestions[i]['DEL'] != "" && !updatedSelectedSubtests.includes("Deletion")) {
                  updatedSelectedSubtests.push("Deletion");
                } else if (initialQuestions[i].Grade == normalizedGrade && initialQuestions[i].Season == data.test.season && initialQuestions[i]['NWE'] != "" && !updatedSelectedSubtests.includes("Nonword Reading")) {
                  updatedSelectedSubtests.push("Nonword Reading");
                } else if (initialQuestions[i].Grade == normalizedGrade && initialQuestions[i].Season == data.test.season && initialQuestions[i]['WRE'] != "" && !updatedSelectedSubtests.includes("Word Reading")) {
                  updatedSelectedSubtests.push("Word Reading");
                }
              }
              setSelectedSubtests(updatedSelectedSubtests);
            }

            if (selectedSubtest) {
              const initialScores = computeScores(groupedCategories, answersUpdated);
              updateQuestionOrder(selectedSubtest, data.test.answers, groupedCategories, initialScores, normalizeGrade(data.test.student.grade), data.test.season);
            }
          });

          break;
        }
      }
    });
  }, []);

  useEffect(() => {
    const storedUser = sessionStorage.getItem("current_user");
    if (!storedUser) {
      return;
    }
    try {
      setCurrentUser(JSON.parse(storedUser));
    } catch (error) {
      console.error("Unable to parse current_user from sessionStorage", error);
    }
  }, []);
  
  useEffect(() => {
    if (categories.length > 0 && Object.keys(answers).length > 0) {
      computeScores(categories, answers);
    }
  }, [categories, answers]);

  const uuidv4 = () => {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      let r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }

  const answerQuestion = (question: any, answer: any, isCurrentAnswer: boolean) => {
    let answersUpdated: any = answers;
    answersUpdated[question.id] = isCurrentAnswer ? null : answer.id;
    setReorderingQuestions(true);
    setAnswers(answersUpdated);
    setCardKey(uuidv4());
    setCurrentQuestionStep(1);
    setCurrentQuestionCorrect(null);

    let token = sessionStorage.getItem("token");
    fetch(ventrisConfig.url + '/api/test/' + routeParams.testId + '/answer', {
      method: 'post',
      headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
      },
      body: JSON.stringify({
        answers: JSON.stringify(answersUpdated),
        text_answers: JSON.stringify(textAnswers),
        numeric_answers: JSON.stringify(numericAnswers),
        subtest_scores: JSON.stringify(subtestScores)
      })
    }).then(function (response) {
      return response.json();
    }).then(async function (data) {
      console.log(data);
      test.answers = data?.test?.answers;
      setTest(test);
      const updatedScores = computeScores(categories, answersUpdated);
      const subtestStatus = statusForSubtest(selectedSubtest, answersUpdated, categories, updatedScores);
      if (subtestStatus === "Complete") {
        if (isFloorCeilingReached(selectedSubtest, answersUpdated, categories)) {
          setShowFloorCeilingModal(true);
        }
        setTimeout(() => {
          launchInitialSubtest(test, answersUpdated, categories, updatedScores, selectedSubtests, normalizeGrade(studentGrade), season);
        }, 5000);
      } else {
        updateQuestionOrder(selectedSubtest, answersUpdated, categories, updatedScores, normalizeGrade(studentGrade), season);
        setReorderingQuestions(false);
      }
    });
  }

  const isFloorCeilingReached = (subtest: string, answers: any, categories: any) => {
    let consecutiveCorrectCount = 0;
    let consecutiveIncorrectCount = 0;

    for (let i = 0; i < categories.length; i++) {
      if (categories[i].name == subtest) {
        for (let j = 0; j < categories[i].subcategories?.length; j++) {
          for (let k = 0; k < categories[i].subcategories[j].questions?.length; k++) {
            const question: any = categories[i].subcategories[j].questions[k];
            if (answers[question.id]) {
              for (let l = 0; l < question.answers.length; l++) {
                if (question.answers[l].id == answers[question.id]) {
                  const answer: any = question.answers[l];
                  if (answer.correct) {
                    if (consecutiveIncorrectCount > 0) {
                      consecutiveIncorrectCount = 0;
                      consecutiveCorrectCount = 1;
                    } else {
                      consecutiveCorrectCount++;
                    }
                  } else {
                    if (consecutiveCorrectCount > 0) {
                      consecutiveCorrectCount = 0;
                      consecutiveIncorrectCount = 1;
                    } else {
                      consecutiveIncorrectCount++;
                    }
                  }
                }
              }
            }
          }
        }
      }
    }

    return consecutiveCorrectCount >= 8 || consecutiveIncorrectCount >= 8;
  }

  const updateTextAnswer = (question: any, answer: any) => {
    let answersUpdated: any = textAnswers;
    answersUpdated[question.id] = answer;
    setTextAnswers(answersUpdated);

    let token = sessionStorage.getItem("token");
    fetch(ventrisConfig.url + '/api/test/' + routeParams.testId + '/answer', {
      method: 'post',
      headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
      },
      body: JSON.stringify({
        answers: JSON.stringify(answers),
        text_answers: JSON.stringify(answersUpdated),
        numeric_answers: JSON.stringify(numericAnswers),
        subtest_scores: JSON.stringify(subtestScores)
      })
    }).then(function (response) {
      return response.json();
    }).then(async function (data) {
      console.log(data);
    });
  }

  const publishTestStatus = async (nextStatus: "completed" | "cancelled") => {
    let token = sessionStorage.getItem("token");
    await fetch(ventrisConfig.url + '/api/realtime/' + routeParams.testId + '/status', {
      method: 'post',
      headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
      },
      body: JSON.stringify({
        status: nextStatus
      })
    });
  }

  const publishTestCompleted = async () => {
    await publishTestStatus("completed");
  }

  const publishTestCancelled = async () => {
    const eventId = `cancel-${routeParams.testId}-${Date.now()}`;

    if (ably && status === "connected" && realtimeChannelUserId) {
      const channel = ably.channels.get(`user:${realtimeChannelUserId}:test:${routeParams.testId}`);
      try {
        await channel.publish("test_cancelled", {
          event_id: eventId,
          status: "cancelled"
        });
        reportRealtimeDiagnostic("test_cancelled", "published", eventId, undefined, channel);
      } catch (publishError) {
        console.error("[realtime] cancel_publish_failed", publishError);
        reportRealtimeDiagnostic("test_cancelled", "publish_failed", eventId, publishError, channel);
      }
    }

    try {
      await publishTestStatus("cancelled");
    } catch (statusError) {
      console.error("[realtime] cancel_status_failed", statusError);
      reportRealtimeDiagnostic("test_cancelled", "status_failed", eventId, statusError);
    }
  }

  const cancelAndExitTest = async () => {
    await publishTestCancelled();
    document.location.href = "/tests";
  }

  const completeTest = () => {
    let token = sessionStorage.getItem("token");
    fetch(ventrisConfig.url + '/api/test/' + routeParams.testId, {
      method: 'put',
      headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
      },
      body: JSON.stringify({
        name: test.name,
        code: test.code,
        status: "Complete",
        subtest_entry_mode: false,
        prompt_mode: (mode == "Prompt"),
        completed_timestamp: testAdministrationDate,
        season: season,
        selected_subtests: selectedSubtests.join("|")
      })
    }).then(function (response) {
      return response.json();
    }).then(async function (data) {
      console.log(data);
      await publishTestCompleted();
      const completedTestId = data?.test?.id || test.id || routeParams.testId;
      const completedStudentId = test.student?.id || test.student_id;
      document.location.href = "/results?students="
        + encodeURIComponent(completedStudentId)
        + "&test="
        + encodeURIComponent(completedTestId);
    });
  }

  const saveCompletedTimestamp = (date: string) => {
    let token = sessionStorage.getItem("token");
    fetch(ventrisConfig.url + '/api/test/' + routeParams.testId, {
      method: 'put',
      headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
      },
      body: JSON.stringify({
        name: test.name,
        code: test.code,
        status: test.status,
        subtest_entry_mode: false,
        prompt_mode: (mode == "Prompt"),
        completed_timestamp: date,
        season: season,
        selected_subtests: selectedSubtests.join("|")
      })
    }).then(function (response) {
      return response.json();
    }).then(async function (data) {
      console.log(data);
      setTestAdministrationDate(date);

      for (let j = 0; j < categories.length; j++) {
        for (let k = 0; k < categories[j].subcategories?.length; k++) {
          categories[j].subcategories[k].questions = [];
          for (let l = 0; l < categories[j].subcategories[k].questionsUnfiltered?.length; l++) {
            if (!data.test?.used_questions?.includes(categories[j].subcategories[k].questionsUnfiltered[l].id)) {
              categories[j].subcategories[k].questions.push(categories[j].subcategories[k].questionsUnfiltered[l]);
            } else {
              console.log("Filtered Out Question: " + categories[j].subcategories[k].questionsUnfiltered[l].id);
            }
          }
        }
      }

      setCategories(categories);
    });
  }

  const saveSeason = (season: string) => {
    setSeason(season);

    let updatedSelectedSubtests: any = [];
    const normalizedGrade = normalizeGrade(studentGrade);
    for (let i = 0; i < initialQuestions.length; i++) {
      if (initialQuestions[i].Grade == normalizedGrade && initialQuestions[i].Season == season && initialQuestions[i]['BLE'] != "" && !updatedSelectedSubtests.includes("Blending")) {
        updatedSelectedSubtests.push("Blending");
      } else if (initialQuestions[i].Grade == normalizedGrade && initialQuestions[i].Season == season && initialQuestions[i]['DEL'] != "" && !updatedSelectedSubtests.includes("Deletion")) {
        updatedSelectedSubtests.push("Deletion");
      } else if (initialQuestions[i].Grade == normalizedGrade && initialQuestions[i].Season == season && initialQuestions[i]['NWE'] != "" && !updatedSelectedSubtests.includes("Nonword Reading")) {
        updatedSelectedSubtests.push("Nonword Reading");
      } else if (initialQuestions[i].Grade == normalizedGrade && initialQuestions[i].Season == season && initialQuestions[i]['WRE'] != "" && !updatedSelectedSubtests.includes("Word Reading")) {
        updatedSelectedSubtests.push("Word Reading");
      }
    }
    setSelectedSubtests(updatedSelectedSubtests);

    let token = sessionStorage.getItem("token");
    fetch(ventrisConfig.url + '/api/test/' + routeParams.testId, {
      method: 'put',
      headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
      },
      body: JSON.stringify({
        name: test.name,
        code: test.code,
        status: test.status,
        subtest_entry_mode: false,
        prompt_mode: (mode == "Prompt"),
        completed_timestamp: testAdministrationDate,
        season: season,
        selected_subtests: selectedSubtests.join("|")
      })
    }).then(function (response) {
      return response.json();
    }).then(async function (data) {
      console.log(data);

      for (let j = 0; j < categories.length; j++) {
        for (let k = 0; k < categories[j].subcategories?.length; k++) {
          categories[j].subcategories[k].questions = [];
          for (let l = 0; l < categories[j].subcategories[k].questionsUnfiltered?.length; l++) {
            if (!data.test?.used_questions?.includes(categories[j].subcategories[k].questionsUnfiltered[l].id)) {
              categories[j].subcategories[k].questions.push(categories[j].subcategories[k].questionsUnfiltered[l]);
            } else {
              console.log("Filtered Out Question: " + categories[j].subcategories[k].questionsUnfiltered[l].id);
            }
          }
        }
      }

      setCategories(categories);
    });
  }

  const saveSelectedSubtests = () => {
    let token = sessionStorage.getItem("token");
    fetch(ventrisConfig.url + '/api/test/' + routeParams.testId, {
      method: 'put',
      headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
      },
      body: JSON.stringify({
        name: test.name,
        code: test.code,
        status: test.status,
        subtest_entry_mode: false,
        prompt_mode: (mode == "Prompt"),
        completed_timestamp: testAdministrationDate,
        season: season,
        selected_subtests: selectedSubtests.join("|")
      })
    }).then(function (response) {
      return response.json();
    }).then(async function (data) {
      console.log(data);

      for (let j = 0; j < categories.length; j++) {
        for (let k = 0; k < categories[j].subcategories?.length; k++) {
          categories[j].subcategories[k].questions = [];
          for (let l = 0; l < categories[j].subcategories[k].questionsUnfiltered?.length; l++) {
            if (!data.test?.used_questions?.includes(categories[j].subcategories[k].questionsUnfiltered[l].id)) {
              categories[j].subcategories[k].questions.push(categories[j].subcategories[k].questionsUnfiltered[l]);
            } else {
              console.log("Filtered Out Question: " + categories[j].subcategories[k].questionsUnfiltered[l].id);
            }
          }
        }
      }
      setCategories(categories);

      launchInitialSubtest(test, answers, categories, scores, selectedSubtests, normalizeGrade(studentGrade), season);
    });
  }

  const isSubtestAvailable = (subtest: string) => {
    let subtestAcronym: string = '';
    if (subtest == 'Blending') {
      subtestAcronym = 'BLE';
    } else if (subtest == 'Deletion') {
      subtestAcronym = 'DEL';
    } else if (subtest == 'Nonword Reading') {
      subtestAcronym = 'NWE';
    } else if (subtest == 'Word Reading') {
      subtestAcronym = 'WRE';
    }

    const normalizedGrade = normalizeGrade(studentGrade);
    for (let i = 0; i < initialQuestions.length; i++) {
      if (initialQuestions[i].Grade == normalizedGrade && initialQuestions[i].Season == season && initialQuestions[i][subtestAcronym] != "") {
        return true;
      }
    }

    return false;
  }

  const availableSubtests = ["Blending", "Deletion", "Nonword Reading", "Word Reading"]
    .filter((subtest) => isSubtestAvailable(subtest));

  const showSubtest = (subtest: string) => {
    return selectedSubtests.includes(subtest);
  }

  const showSection = (subtest: string, section: number) => {
    return true;
  }

  const showQuestion = (subtest: string, question: any, questionIndex: number) => {
    if (selectedDebugQuestionId !== null) {
      return question.id === selectedDebugQuestionId;
    }

    for (let i = 0; i < categories.length; i++) {
      if (categories[i].name === subtest) {
        for (let j = 0; j < categories[i].subcategories?.length; j++) {
          for (let k = 0; k < categories[i].subcategories[j].questions?.length; k++) {
            if (!answers[categories[i].subcategories[j].questions[k].id]) {
              if (questionIndex === k) {
                return true;
              }
              break;
            }
          }
        }
      }
    }

    return false;
  }

  const computeScores = (categories: any, answers: any) => {
    let scoresUpdated: any = {};
    
    for (let i = 0; i < categories.length; i++) {
      let thetas: any = [];
      let likelihoods: any = {};
      let maxTheta = 0;
      let maxThetaLikelihood = -9999;
      let informationSum = 0;
      let standardError = 0;

      for (let j = 0; j < categories[i].subcategories.length; j++) {
        for (let k = 0; k < categories[i].subcategories[j].questions.length; k++) {
          const question: any = categories[i].subcategories[j].questions[k];
          if (question.id in answers && question.discrimination && question.difficulty) {
            for (let l = 0; l < question.answers.length; l++) {
              if (question.answers[l].id == answers[question.id]) {
                const answer: any = question.answers[l];
                let probabilities: any = {};
                for (let theta = -5; theta <= 5; theta += 0.01) {
                  const probability = 1/(1 + Math.exp(-1.7*question.discrimination*(theta-question.difficulty)));
                  if (answer.correct) {
                    probabilities[theta] = probability;
                  } else {
                    probabilities[theta] = 1 - probability;
                  }
                }
                thetas.push(probabilities);
              }
            }
          }
        }
      }

      for (let theta = -5; theta <= 5; theta += 0.01) {
        likelihoods[theta] = 1;
        for (let i = 0; i < thetas.length; i++) {
          likelihoods[theta] *= thetas[i][theta];
        }

        if (likelihoods[theta] > maxThetaLikelihood) {
          maxThetaLikelihood = likelihoods[theta];
          maxTheta = theta;
        }
      }

      for (let j = 0; j < categories[i].subcategories.length; j++) {
        for (let k = 0; k < categories[i].subcategories[j].questions.length; k++) {
          const question: any = categories[i].subcategories[j].questions[k];
          if (question.id in answers && question.discrimination && question.difficulty) {
            for (let l = 0; l < question.answers.length; l++) {
              if (question.answers[l].id == answers[question.id]) {
                const probability = 1/(1 + Math.exp(-1.7*question.discrimination*(maxTheta-question.difficulty)));
                const information = (Math.pow(1.7*question.discrimination, 2)*(1 - probability)*probability);
                informationSum += information;
              }
            }
          }
        }
      }

      standardError = 1/Math.sqrt(informationSum);

      scoresUpdated[categories[i].name] = {
        thetas,
        likelihoods,
        maxTheta,
        maxThetaLikelihood,
        informationSum,
        standardError
      }
    }

    setScores(scoresUpdated);
    return scoresUpdated;
  }

  const updateQuestionOrder = (subtest: string, answers: any, categories: any, scores: any, studentGrade: any, season: any) => {
    const normalizedGrade = normalizeGrade(studentGrade);
    let subtestAcronym: string = '';
    if (subtest == 'Blending') {
      subtestAcronym = 'BLE';
    } else if (subtest == 'Deletion') {
      subtestAcronym = 'DEL';
    } else if (subtest == 'Nonword Reading') {
      subtestAcronym = 'NWE';
    } else if (subtest == 'Word Reading') {
      subtestAcronym = 'WRE';
    }

    let reorderedQuestions: any = [];
    for (let i = 0; i < categories?.length; i++) {
      if (categories[i].name == subtest) {
        // Find the initial five questions:
        for (let j = 0; j < initialQuestions.length; j++) {
          if (initialQuestions[j].Grade == normalizedGrade && initialQuestions[j].Season == season && initialQuestions[j].Question == (reorderedQuestions.length + 1)) {
            let difficultyDifference = 10000;
            let selectedQuestion: any = null;
            for (let k = 0; k < categories[i].subcategories[0].questions?.length; k++) {
              if (Math.abs(categories[i].subcategories[0].questions[k].difficulty - initialQuestions[j][subtestAcronym]) < difficultyDifference) {
                let isInitialQuestion = false;
                for (let l = 0; l < reorderedQuestions.length; l++) {
                  if (reorderedQuestions[l].id == categories[i].subcategories[0].questions[k].id) {
                    isInitialQuestion = true;
                  }
                }
                if (!isInitialQuestion) {
                  difficultyDifference = Math.abs(categories[i].subcategories[0].questions[k].difficulty - initialQuestions[j][subtestAcronym]);
                  selectedQuestion = categories[i].subcategories[0].questions[k];
                }
              }
            }
            if (selectedQuestion) {
              reorderedQuestions.push(selectedQuestion);
            }
          }
        }

        // Insert additional questions that have already been answered in the order they were answered:
        for (let j = 0; j < answers?.length; j++) {
          let isInitialQuestion = false;
          for (let k = 0; k < reorderedQuestions.length; k++) {
            if (reorderedQuestions[k].id == answers[j].test_schema_question_id) {
              isInitialQuestion = true;
            }
          }
          if (!isInitialQuestion) {
            for (let k = 0; k < categories[i].subcategories[0].questions?.length; k++) {
              if (categories[i].subcategories[0].questions[k].id == answers[j].test_schema_question_id) {
                reorderedQuestions.push(categories[i].subcategories[0].questions[k]);
                break;
              }
            }
          }
        }

        // Find the next question based on the scoring logic:
        let difficultyDifference = 10000;
        let selectedQuestion: any = null;
        for (let k = 0; k < categories[i].subcategories[0].questions?.length; k++) {
          if (Math.abs(categories[i].subcategories[0].questions[k].difficulty - (scores[subtest] ? scores[subtest].maxTheta : 0)) < difficultyDifference) {
            let isInitialQuestion = false;
            for (let l = 0; l < reorderedQuestions.length; l++) {
              if (reorderedQuestions[l].id == categories[i].subcategories[0].questions[k].id) {
                isInitialQuestion = true;
              }
            }
            if (!isInitialQuestion) {
              difficultyDifference = Math.abs(categories[i].subcategories[0].questions[k].difficulty - (scores[subtest] ? scores[subtest].maxTheta : 0));
              selectedQuestion = categories[i].subcategories[0].questions[k];
            }
          }
        }
        if (selectedQuestion) {
          reorderedQuestions.push(selectedQuestion);
        }

        // Then add all the rest of the questions in their original order:
        for (let k = 0; k < categories[i].subcategories[0].questions?.length; k++) {
          let isInitialQuestion = false;
          for (let l = 0; l < reorderedQuestions.length; l++) {
            if (reorderedQuestions[l].id == categories[i].subcategories[0].questions[k].id) {
              isInitialQuestion = true;
            }
          }
          if (!isInitialQuestion) {
            reorderedQuestions.push(categories[i].subcategories[0].questions[k]);
          }
        }

        categories[i].subcategories[0].questions = reorderedQuestions;
        break;
      }
    }

    setCategories(JSON.parse(JSON.stringify(categories)));

    setCurrentQuestionStep(1);
    setCurrentQuestionCorrect(null);

    if (role == "Examiner") {
      for (let i = 0; i < reorderedQuestions.length; i++) {
        if (!answers[reorderedQuestions[i].id]) {
          let token = sessionStorage.getItem("token");
          fetch(ventrisConfig.url + '/api/realtime/' + routeParams.testId + '/question', {
            method: 'post',
            headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token
            },
            body: JSON.stringify({
              question: reorderedQuestions[i].id,
              category: subtest
            })
          }).then(function (response) {
            return response.json();
          }).then(async function (data) {
            console.log(data);
          });
          break;
        }
      }
    }
  }

  const toggleSelectedSubtest = (subtest: string) => {
    let updatedSelectedSubtests = JSON.parse(JSON.stringify(selectedSubtests));
    if (updatedSelectedSubtests.includes(subtest)) {
      updatedSelectedSubtests = updatedSelectedSubtests.filter((item: string) => item !== subtest);
    } else {
      updatedSelectedSubtests.push(subtest);
    }

    setSelectedSubtests(updatedSelectedSubtests);
  }

  const statusForSubtest = (subtest: string, answers: any, categories: any, scores: any) => {
    let answerCount = 0;
    let correctAnswerCount = 0;
    let consecutiveCorrectCount = 0;
    let consecutiveIncorrectCount = 0;

    for (let i = 0; i < categories.length; i++) {
      if (categories[i].name == subtest) {
        for (let j = 0; j < categories[i].subcategories?.length; j++) {
          for (let k = 0; k < categories[i].subcategories[j].questions?.length; k++) {
            const question: any = categories[i].subcategories[j].questions[k];
            if (answers[question.id]) {
              answerCount++;
              for (let l = 0; l < question.answers.length; l++) {
                if (question.answers[l].id == answers[question.id]) {
                  const answer: any = question.answers[l];
                  if (answer.correct) {
                    correctAnswerCount++;
                    if (consecutiveIncorrectCount > 0) {
                      consecutiveIncorrectCount = 0;
                      consecutiveCorrectCount = 1;
                    } else {
                      consecutiveCorrectCount++;
                    }
                  } else {
                    if (consecutiveCorrectCount > 0) {
                      consecutiveCorrectCount = 0;
                      consecutiveIncorrectCount = 1;
                    } else {
                      consecutiveIncorrectCount++;
                    }
                  }
                }
              }
            }
          }
        }
      }
    }

    console.log("Consecutive Correct Count: " + consecutiveCorrectCount);
    console.log("Consecutive Incorrect Count: " + consecutiveIncorrectCount);
    
    if (scores[subtest] && scores[subtest].standardError < 0.316 && answerCount >= 7) {
      return "Complete";
    } else if (answerCount >= 10) {
      return "Complete"
    } else if (consecutiveCorrectCount >= 8) {
      return "Complete"
    }else if (consecutiveIncorrectCount >= 8) {
      return "Complete"
    } else if (answerCount > 0) {
      return "In Progress";
    }

    return "Incomplete";
  }

  const launchInitialSubtest = (test: any, answers: any, categories: any, scores: any, selectedSubtests: any, studentGrade: any, season: any) => {
    if (selectedSubtests.includes("Blending") && statusForSubtest("Blending", answers, categories, scores) !== "Complete") {
      openSubtest("Blending", answers, categories, scores, studentGrade, season);
      if (statusForSubtest("Blending", answers, categories, scores) === "In Progress") {
        setShownInstructionsForSubtest(true);
        setShownExamplesForSubtest(true);
      }
      setShowBeginSubtestButton(true);
      setReorderingQuestions(false);
    } else if (selectedSubtests.includes("Deletion") && statusForSubtest("Deletion", answers, categories, scores) !== "Complete") {
      openSubtest("Deletion", answers, categories, scores, studentGrade, season);
      if (statusForSubtest("Deletion", answers, categories, scores) === "In Progress") {
        setShownInstructionsForSubtest(true);
        setShownExamplesForSubtest(true);
      }
      setShowBeginSubtestButton(true);
      setReorderingQuestions(false);
    } else if (selectedSubtests.includes("Nonword Reading") && statusForSubtest("Nonword Reading", answers, categories, scores) !== "Complete") {
      openSubtest("Nonword Reading", answers, categories, scores, studentGrade, season);
      if (statusForSubtest("Nonword Reading", answers, categories, scores) === "In Progress") {
        setShownInstructionsForSubtest(true);
        setShownExamplesForSubtest(true);
      }
      setShowBeginSubtestButton(true);
      setReorderingQuestions(false);
    } else if (selectedSubtests.includes("Word Reading") && statusForSubtest("Word Reading", answers, categories, scores) !== "Complete") {
      openSubtest("Word Reading", answers, categories, scores, studentGrade, season);
      if (statusForSubtest("Word Reading", answers, categories, scores) === "In Progress") {
        setShownInstructionsForSubtest(true);
        setShownExamplesForSubtest(true);
      }
      setShowBeginSubtestButton(true);
      setReorderingQuestions(false);
    } else if (test.status !== "Complete") {
      completeTest();
    }
  }

  const openSubtest = (subtest: string, answers: any, categories: any, scores: any, studentGrade: any, season: any) => {
    updateQuestionOrder(subtest, answers, categories, scores, studentGrade, season);
    setSelectedSubtest(subtest);
    setShownInstructionsForSubtest(false);
    setPlayedInstructionCount(0);
    setShownExamplesForSubtest(false);
    setShownExampleCount(0);
    setSelectedDebugQuestionId(null);
  }

  const progressForSubtest = (subtest: string) => {
    let answerCount = 0;

    for (let i = 0; i < categories.length; i++) {
      if (categories[i].name == subtest) {
        for (let j = 0; j < categories[i].subcategories?.length; j++) {
          for (let k = 0; k < categories[i].subcategories[j].questions?.length; k++) {
            if (answers[categories[i].subcategories[j].questions[k].id] || numericAnswers[categories[i].subcategories[j].questions[k].id]) {
              answerCount++;
            }
          }
        }
      }
    }

    if (answerCount > 10) {
      answerCount = 10;
    }

    return answerCount;
  }

  const instructionCountForSubtest = (subtest: string) => {
    if (subtest === "Blending") {
      return 3;
    } else if (subtest === "Deletion") {
      return 2;
    } else if (subtest === "Nonword Reading") {
      return 2;
    } else if (subtest === "Word Reading") {
      return 1;
    }

    return 1;
  }

  const playNextAudioInstruction = (index: any) => {
    let published = false;

    if (selectedSubtest === "Blending") {
      published = playAudio(selectedSubtest, "ble_d_" + index);
    } else if (selectedSubtest === "Deletion") {
      published = playAudio(selectedSubtest, "del_d_" + index);
    } else if (selectedSubtest === "Nonword Reading") {
      published = playAudio(selectedSubtest, "nre_d_" + index);
      if (published && playedInstructionCount === 1) {
        showWord(selectedSubtest, "zuk");
      }
    } else if (selectedSubtest === "Word Reading") {
      published = playAudio(selectedSubtest, "wre_d_" + index);
    }

    if (published) {
      setPlayedInstructionCount(playedInstructionCount + 1);
    }
  }

  const getExampleQuestion = (subtest: string, exampleIndex: number) => {
    if (subtest === "Blending" && exampleIndex === 0) {
      return {
        item_name: "ble_p_something",
        question: "some - thing",
        answer: "something",
        correct: "ble_p_correct_1",
        incorrect: "ble_p_something_incorrect"
      };
    } else if (subtest === "Blending" && exampleIndex === 1) {
      return {
        item_name: "ble_p_toothbrush",
        question: "tooth - brush",
        answer: "toothbrush",
        correct: "ble_p_correct_2",
        incorrect: "ble_p_toothbrush_incorrect"
      };
    } else if (subtest === "Deletion" && exampleIndex === 0) {
      return {
        item_name: "del_p_baseball_1",
        item_name_2: "del_p_baseball_2",
        question: "baseball without /base/",
        answer: "ball",
        correct: "del_p_correct",
        incorrect: "del_p_baseball_incorrect"
      };
    } else if (subtest === "Deletion" && exampleIndex === 1) {
      return {
        item_name: "del_p_doghouse_1",
        item_name_2: "del_p_doghouse_2",
        question: "doghouse without /dog/",
        answer: "house",
        correct: "del_p_correct",
        incorrect: "del_p_doghouse_incorrect"
      };
    } else if (subtest === "Nonword Reading" && exampleIndex === 0) {
      return {
        item_name: "nre_p_dit",
        question: "dit",
        answer: "dit",
        caption: 'like "bit"',
        ipa_pronunciation: "/dɪt/",
        phonics_pronunciation: "/d/ /ĭ/ /t/",
        correct: "nre_p_dit_correct",
        incorrect: "nre_p_dit_incorrect"
      };
    } else if (subtest === "Nonword Reading" && exampleIndex === 1) {
      return {
        item_name: "nre_p_vat",
        question: "vat",
        answer: "vat",
        caption: 'like "bat"',
        ipa_pronunciation: "/væt/",
        phonics_pronunciation: "/v/ /ă/ /t/",
        correct: "nre_p_vat_correct",
        incorrect: "nre_p_vat_incorrect"
      };
    } else if (subtest === "Word Reading" && exampleIndex === 0) {
      return {
        item_name: "wre_p_the",
        question: "the",
        answer: "the",
        correct: "wre_p_go_correct",
        incorrect: "wre_p_the_incorrect",
        submission: "wre_d_2"
      };
    } else if (subtest === "Word Reading" && exampleIndex === 1) {
      return {
        item_name: "wre_p_go",
        question: "go",
        answer: "go",
        correct: "wre_p_go_correct",
        incorrect: "wre_p_go_incorrect",
        submission: "wre_d_2"
      };
    }

    return {
      item_name: "example_" + (exampleIndex + 1),
      question: "some - thing",
      answer: "something",
      correct: "",
      incorrect: ""
    };
  }

  const getCorrectAnswerCaption = (question: any) => {
    const correctAnswer = question.answers?.find((answer: any) => answer.correct === true || Number(answer.correct) === 1)
      || question.answers?.[0];

    return correctAnswer?.caption || correctAnswer?.answer || '';
  };

  const getExampleAnswerCaption = (subtest: string, exampleIndex: number) => {
    const example = getExampleQuestion(subtest, exampleIndex) as any;
    return example.caption || example.answer || '';
  };

  const updateShownExampleCount = () => {
    setShownExampleCount(shownExampleCount + 1);
    setCurrentQuestionStep(1);
    setCurrentQuestionCorrect(null);

    if (shownExampleCount === 1) {
      setShownExamplesForSubtest(true);
    }
  }

  const reportRealtimeDiagnostic = useCallback((event: string, diagnosticStatus: string, eventId?: string, error?: unknown, channel?: any) => {
    const token = sessionStorage.getItem("token");
    const errorMessage = error instanceof Error ? error.message : (error ? String(error) : undefined);
    const payload = {
      event,
      event_id: eventId || null,
      status: diagnosticStatus,
      connection_id: ably?.connection?.id || null,
      connection_state: ably?.connection?.state || status,
      channel: channel?.name || null,
      channel_state: channel?.state || null,
      error: errorMessage || null,
    };

    console.info("[realtime] diagnostic", payload);

    fetch(ventrisConfig.url + '/api/realtime/' + routeParams.testId + '/ack', {
      method: 'post',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
      },
      body: JSON.stringify(payload)
    }).catch((diagnosticError) => {
      console.error("[realtime] diagnostic_failed", diagnosticError);
    });
  }, [ably, routeParams.testId, status]);

  const playAudio = (category: string, itemName: string) => {
    if (role === "Examiner" && studentRealtimeStatus !== "ready") {
      setAudioState('error');
      setAudioStatusMessage('Audio was not sent because the student audio connection is not ready.');
      reportRealtimeDiagnostic("play_audio", "blocked_student_not_ready");
      return false;
    }

    setAudioState('sending');
    setAudioStatusMessage('Sending audio to the student.');
    let token = sessionStorage.getItem("token");
    fetch(ventrisConfig.url + '/api/realtime/' + routeParams.testId + '/audio', {
      method: 'post',
      headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
      },
      body: JSON.stringify({
        url: ventrisConfig.url + '/assets/wra/' + category.toLowerCase().replace(' ', '-') + '/items/' + itemName + '.mp3'
      })
    }).then(async function (response) {
      const data = await response.json();
      if (!response.ok || !data.ok) {
        throw new Error(data.message || `Audio request failed with status ${response.status}`);
      }
      console.info("[realtime] audio_publish_response", {
        ok: response.ok && data.ok,
        eventId: data.event_id,
        testId: routeParams.testId,
      });
      setAudioState('sent');
      setAudioStatusMessage('Audio sent to the student.');
    }).catch((publishError) => {
      console.error("[realtime] audio_publish_failed", publishError);
      setAudioState('error');
      setAudioStatusMessage('Audio could not be sent. Try again.');
    });

    setCurrentQuestionStep(2);
    return true;
  }

  const showWord = (category: string, itemName: string) => {
    if (role === "Examiner" && studentRealtimeStatus !== "ready") {
      reportRealtimeDiagnostic("show_image", "blocked_student_not_ready");
      return false;
    }

    const sanitizedItemName = itemName.replace(/["“”'‘’()[\]{}]/g, "");
    let token = sessionStorage.getItem("token");
    fetch(ventrisConfig.url + '/api/realtime/' + routeParams.testId + '/image', {
      method: 'post',
      headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
      },
      body: JSON.stringify({
        url: sanitizedItemName
      })
    }).then(function (response) {
      return response.json();
    }).then(async function (data) {
      // console.log(data);
    });

    setCurrentQuestionStep(2);
    return true;
  }

  const studentPromptFontFamily = (wordMarkup: string | null) => {
    const plainTextWord = (wordMarkup || "").replace(/<[^>]*>/g, "");

    return /j/i.test(plainTextWord)
      ? '"Arial", "Helvetica", sans-serif'
      : '"Questrial", "Arial", sans-serif';
  }

  const renderExaminerHeaderTitle = (subtitle: string) => (
    <div className="flex-grow test-header-test-name">
      WRA (WORD READING ASSESSMENT)
      <br />
      {subtitle}
      {role === "Examiner" && test?.code ? (
        <>
          <div className="test-header-join-code">Join Code: {test.code}</div>
          <div className={`test-header-student-status test-header-student-status-${studentRealtimeStatus}`}>
            {studentRealtimeStatus === "ready"
              ? "Student Ready"
              : studentRealtimeStatus === "connected"
                ? "Student Connected - Waiting for Begin Test"
                : "Waiting for Student"}
          </div>
          <WraAudioStatus state={audioState} message={audioStatusMessage} />
        </>
      ) : null}
    </div>
  );

  const renderStudentBranding = () => (
    <>
      <img src={wra} alt="WRA Logo" className="student-wra-logo" />
      <img src={logoGrey} alt="Ventris Learning Logo" className="student-ventris-footer-logo" />
    </>
  );

  const renderStudentAudioIndicator = () => (
    <>
      {audioPlaying ? <WraAudioPlayingIcon /> : <span className="audio-stopped-wrapper"><WraAudioStoppedIcon /></span>}
      <WraAudioStatus state={audioState} message={audioStatusMessage} className="visually-hidden" />
    </>
  );

  const allowAudio = async () => {
    try {
      if (!audioContext) {
        audioContext = new window.AudioContext();
      }

      if (audioContext.state !== "running") {
        await audioContext.resume();
      }

      if (audioContext.state !== "running") {
        throw new Error(`Audio context is ${audioContext.state}.`);
      }

      const buffer = audioContext.createBuffer(1, 1, 22050);
      const source = audioContext.createBufferSource();
      source.buffer = buffer;
      source.connect(audioContext.destination);
      source.start(0);
      source.stop(0);

      setAllowedAudio(true);
      setAudioState('complete');
      setAudioStatusMessage('Audio is ready.');

      if (studentChannelRef.current) {
        await studentChannelRef.current.presence.update({
          role: "student",
          test_id: routeParams.testId,
          audio_ready: true,
        });
        reportRealtimeDiagnostic("student_readiness", "ready", undefined, undefined, studentChannelRef.current);
      }
    } catch (audioError) {
      console.error("[realtime] student_audio_initialization_failed", audioError);
      setAllowedAudio(false);
      setAudioState('error');
      setAudioStatusMessage('Audio could not be enabled. Check this device’s audio settings and try again.');
      reportRealtimeDiagnostic("student_readiness", "failed", undefined, audioError, studentChannelRef.current);
    }
  }

  useEffect(() => {
    if (!ably || status !== "connected" || role !== "Examiner" || !realtimeChannelUserId) {
      setStudentRealtimeStatus("waiting");
      return;
    }

    let cancelled = false;
    const channelName = `user:${realtimeChannelUserId}:test:${routeParams.testId}`;
    const channel: any = ably.channels.get(channelName);

    const refreshStudentReadiness = async () => {
      try {
        const members = await channel.presence.get();
        if (cancelled) {
          return;
        }

        const studentMembers = members.filter((member: any) => member.data?.role === "student");
        const nextStatus = studentMembers.some((member: any) => member.data?.audio_ready === true)
          ? "ready"
          : studentMembers.length > 0
            ? "connected"
            : "waiting";

        setStudentRealtimeStatus(nextStatus);
        reportRealtimeDiagnostic("student_presence", nextStatus, undefined, undefined, channel);
      } catch (presenceError) {
        if (!cancelled) {
          setStudentRealtimeStatus("waiting");
          console.error("[realtime] student_presence_failed", presenceError);
          reportRealtimeDiagnostic("student_presence", "failed", undefined, presenceError, channel);
        }
      }
    };

    const onPresenceChange = () => {
      refreshStudentReadiness();
    };

    const monitorStudent = async () => {
      try {
        await channel.attach();
        if (cancelled) {
          return;
        }
        await channel.presence.subscribe(onPresenceChange);
        await refreshStudentReadiness();
      } catch (subscriptionError) {
        if (!cancelled) {
          setStudentRealtimeStatus("waiting");
          console.error("[realtime] student_presence_subscription_failed", subscriptionError);
          reportRealtimeDiagnostic("student_presence_subscription", "failed", undefined, subscriptionError, channel);
        }
      }
    };

    monitorStudent();

    return () => {
      cancelled = true;
      setStudentRealtimeStatus("waiting");
      channel.presence.unsubscribe(onPresenceChange);
    };
  }, [ably, status, role, routeParams.testId, realtimeChannelUserId, reportRealtimeDiagnostic]);

  useEffect(() => {
    if (!ably || status !== "connected" || role !== "Student" || !realtimeChannelUserId) return;

    let cancelled = false;
    const channelName = `user:${realtimeChannelUserId}:test:${routeParams.testId}`;
    const channel: any = ably.channels.get(channelName);
    studentChannelRef.current = channel;

    const onChannelState = (stateChange: any) => {
      reportRealtimeDiagnostic(
        "channel_state",
        stateChange.current,
        undefined,
        stateChange.reason?.message,
        channel
      );
    };

    const onMessage = async (msg: any) => {
        const messageData = msg.data && typeof msg.data === "object"
          ? msg.data
          : { url: msg.data };
        const eventId = messageData.event_id;
        const messageStatus = typeof messageData.status === "string"
          ? messageData.status.toLowerCase()
          : "";

        reportRealtimeDiagnostic(msg.name, "received", eventId, undefined, channel);

        if (msg.name === 'question_changed') {
          setCurrent(messageData);
          setCurrentImage(null);
          setAudioPlaying(false);
          setAudioState('idle');
          setAudioStatusMessage('');
        } else if (msg.name === 'play_audio' && role === 'Student') {
          try {
            setAudioPlaying(false);
            setAudioState('loading');
            setAudioStatusMessage('Loading audio.');
            const res = await fetch(messageData.url);
            if (!res.ok) {
              throw new Error(`Audio request failed with status ${res.status}`);
            }
            const arrayBuffer = await res.arrayBuffer();
            if (!audioContext) {
              throw new Error("Audio context has not been initialized by a user interaction.");
            }
            if (audioContext.state !== "running") {
              await audioContext.resume();
            }
            if (audioContext.state !== "running") {
              throw new Error(`Audio context is ${audioContext.state}.`);
            }
            audioBuffer = await audioContext.decodeAudioData(arrayBuffer);
            const source = audioContext.createBufferSource();
            source.onended = () => {
              setAudioPlaying(false);
              setAudioState('complete');
              setAudioStatusMessage('Audio finished.');
              reportRealtimeDiagnostic("play_audio", "completed", eventId, undefined, channel);
            };
            source.buffer = audioBuffer;
            source.connect(audioContext.destination);
            source.start(0);
            setAudioPlaying(true);
            setAudioState('playing');
            setAudioStatusMessage('Audio is playing.');
            reportRealtimeDiagnostic("play_audio", "started", eventId, undefined, channel);
          } catch (audioError) {
            console.error("[realtime] audio_playback_failed", audioError);
            setAudioPlaying(false);
            setAudioState('error');
            setAudioStatusMessage('Audio could not be played. Ask the examiner to try again.');
            reportRealtimeDiagnostic("play_audio", "failed", eventId, audioError, channel);
          }
        } else if (msg.name === 'show_image' && role === 'Student') {
          setCurrentImage(messageData.url);
        } else if ((msg.name === 'test_completed' || messageStatus === 'completed') && role === 'Student') {
          setStudentTestCompleted(true);
          setStudentTestCancelled(false);
          setCurrent(null);
          setCurrentImage(null);
          setAudioPlaying(false);
          setAudioState('idle');
          setAudioStatusMessage('');
        } else if ((msg.name === 'test_cancelled' || msg.name === 'test_canceled' || messageStatus === 'cancelled' || messageStatus === 'canceled') && role === 'Student') {
          setStudentTestCancelled(true);
          setStudentTestCompleted(false);
          setCurrent(null);
          setCurrentImage(null);
          setAudioPlaying(false);
          setAudioState('idle');
          setAudioStatusMessage('');
        }
    };

    channel.on(onChannelState);

    const subscribe = async () => {
      try {
        await channel.subscribe(onMessage);
        if (cancelled) {
          return;
        }
        await channel.presence.enter({
          role: "student",
          test_id: routeParams.testId,
          audio_ready: allowedAudio,
        });
        reportRealtimeDiagnostic("subscription", "attached", undefined, undefined, channel);
      } catch (subscriptionError) {
        console.error("[realtime] subscription_failed", subscriptionError);
        reportRealtimeDiagnostic("subscription", "failed", undefined, subscriptionError, channel);
      }
    };

    subscribe();

    return () => {
      cancelled = true;
      studentChannelRef.current = null;
      channel.off(onChannelState);
      channel.unsubscribe(onMessage);
      channel.presence.leave({}).catch(() => {});
    };
  }, [ably, status, role, routeParams.testId, realtimeChannelUserId, allowedAudio, reportRealtimeDiagnostic]);

  if (!test.id) {
    return (
      <Container fluid as="main" id="main-content" tabIndex={-1} aria-busy="true">
        <h1 className="visually-hidden">WRA Test</h1>
        <Row>
          <Col>
            <div className="student-prompt">
              {role === 'Student' ? renderStudentBranding() : <img src={logoGrey} alt="Ventris Learning Logo" className="ventris-header-logo" />}
              <br /><br /><br /><br />
              <span role="status">
                <Spinner animation="border" variant="secondary" />
                <span className="visually-hidden">Loading test.</span>
              </span>
            </div>
          </Col>
        </Row>
      </Container>
    );
  }

  if (role === 'Student') {
    return (
      <Container fluid as="main" id="main-content" tabIndex={-1}>
        <h1 className="visually-hidden">WRA Student Test</h1>
        <Row>
          <Col>
            {studentTestCancelled ?
            <div className="student-prompt student-prompt-word-screen">
              {renderStudentBranding()}
              <div className="student-prompt-word-view student-complete-view">
                <h3 className="student-complete-title">Test Cancelled</h3>
                <Button className="ventris-button-primary ventris-button-primary-teal student-complete-button" onClick={() => { document.location.href = "/join"; }}>
                  Return to Join Screen
                </Button>
              </div>
            </div> :
            !allowedAudio ?
            <div className="student-prompt">
              {renderStudentBranding()}
              <br /><br /><br /><br />
              <Button className="ventris-button-primary ventris-button-primary-teal" onClick={allowAudio}>Begin Test</Button>
              <WraAudioStatus state={audioState} message={audioStatusMessage} className="visually-hidden" />
            </div> :
            <>
              {studentTestCompleted ?
              <div className="student-prompt student-prompt-word-screen">
                {renderStudentBranding()}
                <div className="student-prompt-word-view student-complete-view">
                  <h3 className="student-complete-title">Test has been completed. Good job!</h3>
                  <Button className="ventris-button-primary ventris-button-primary-teal student-complete-button" onClick={() => { document.location.href = "/"; }}>
                    Return to Home Screen
                  </Button>
                </div>
              </div> :
              current ?
              <div className="student-prompt student-prompt-word-screen">
                {renderStudentBranding()}
                <div className="student-prompt-word-view">
                  {schema?.questions?.map((question: any) => 
                    <>
                    {question.id == current.question ?
                    <>
                      {current.category == "Blending" || current.category == "Deletion" ? renderStudentAudioIndicator() : null }
                      {current.category == "Nonword Reading" || current.category == "Word Reading" ? (currentImage ? <><div className="student-word-prompt" style={{ fontFamily: studentPromptFontFamily(currentImage) }} dangerouslySetInnerHTML={{__html: currentImage}}></div><WraAudioStatus state={audioState} message={audioStatusMessage} className="visually-hidden" /></> : <WraWordIcon />) : null }
                    </> : null}
                    </>
                  )}
                </div>
              </div> :
              <div className="student-prompt student-prompt-word-screen">
                {renderStudentBranding()}
                <div className="student-prompt-word-view">
                  {currentImage ? <><div className="student-word-prompt" style={{ fontFamily: studentPromptFontFamily(currentImage) }} dangerouslySetInnerHTML={{__html: currentImage}}></div><WraAudioStatus state={audioState} message={audioStatusMessage} className="visually-hidden" /></> : renderStudentAudioIndicator()}
                </div>
              </div> }
            </> }
          </Col>
        </Row>
      </Container>
    );
  }

  return (
    <Container fluid as="main" id="main-content" tabIndex={-1} className="ventris-content-wrapper">
      <h1 className="visually-hidden">WRA Examiner Test</h1>
      <Modal show={showFloorCeilingModal} onHide={() => setShowFloorCeilingModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Subtest Ended</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Alert variant="warning" className="mb-0">
            Subtest ended because a floor or ceiling was reached. An accurate estimate of ability can not be obtained. This subtest may not be appropriate for this test taker.
          </Alert>
        </Modal.Body>
        <Modal.Footer>
          <Button className="ventris-button-primary ventris-button-primary-teal full-width" onClick={() => setShowFloorCeilingModal(false)}>OK</Button>
        </Modal.Footer>
      </Modal>
      <Container>
        <Row>
          <Col>
            <br /><br />
            {test.status !== "Complete" && !selectedSubtest && !shownSubtestSelection ?
            <Card className="content-card" key={cardKey}>
              <div className="wra-test-header wra-test-header-launch">
                <div className="wra-test-header-left">
                  <Link to="/"><img src={logo} alt="Ventris Learning Logo" className="ventris-header-logo-wra" /></Link>
                </div>
                <div className="test-header-student-name">
                  {studentName}
                </div>
                <div className="wra-test-header-right">
                  {renderExaminerHeaderTitle("Select Subtests")}
                  <img src={wra} alt="WRA Logo" className="wra-logo wra-logo-launch" />
                </div>
              </div>
              <hr />
              <div className="test-instructions center">{selectedSubtests.length === 0 ? "0" : (selectedSubtests.length*3 + " - " + selectedSubtests.length*4)} MINUTES TO COMPLETE</div>
              <h3 className="test-header center">WRA (Word Reading Assessment)</h3>
              <div className="center">Select the subtests you'd like to include in this assessment, and then click the "Continue to Instructions" button.</div>
              <br /><br />
              <div className="subtest-selection-wrapper flex flex-column flex-gap">
                {availableSubtests.length === 0 ?
                <Alert variant="warning">
                  No WRA subtests are available for grade "{studentGrade}" in the {season} season. Please verify the student's grade.
                </Alert> : null}
                {isSubtestAvailable("Blending") ?
                <label className={selectedSubtests.includes("Blending") ? "subtest-checkbox-selected" : "subtest-checkbox-deselected"}>
                  <input type="checkbox" checked={selectedSubtests.includes("Blending")} onChange={() => toggleSelectedSubtest("Blending")} />
                  Blending
                </label> : null }
                {isSubtestAvailable("Deletion") ?
                <label className={selectedSubtests.includes("Deletion") ? "subtest-checkbox-selected" : "subtest-checkbox-deselected"}>
                  <input type="checkbox" checked={selectedSubtests.includes("Deletion")} onChange={() => toggleSelectedSubtest("Deletion")} />
                  Deletion
                </label> : null }
                {isSubtestAvailable("Nonword Reading") ?
                <label className={selectedSubtests.includes("Nonword Reading") ? "subtest-checkbox-selected" : "subtest-checkbox-deselected"}>
                  <input type="checkbox" checked={selectedSubtests.includes("Nonword Reading")} onChange={() => toggleSelectedSubtest("Nonword Reading")} />
                  Nonword Reading
                </label> : null }
                {isSubtestAvailable("Word Reading") ?
                <label className={selectedSubtests.includes("Word Reading") ? "subtest-checkbox-selected" : "subtest-checkbox-deselected"}>
                  <input type="checkbox" checked={selectedSubtests.includes("Word Reading")} onChange={() => toggleSelectedSubtest("Word Reading")} />
                  Word Reading
                </label> : null }
                <br />
                <div className="center">Please select the date and season in which this test is being administered:</div>
                <Form.Control
                  type="date"
                  placeholder="Test Administration Date"
                  className={`test-answer-inline ${debugMode ? '' : 'ventris-dropdown-disabled'}`}
                  defaultValue={test?.completed_timestamp?.split(' ')[0]}
                  disabled={!debugMode}
                  onChange={(event) => saveCompletedTimestamp(event.target.value)}
                />
                <Dropdown>
                  <Dropdown.Toggle id="wra-season-menu" className={`ventris-dropdown ${debugMode ? '' : 'ventris-dropdown-disabled'}`} disabled={!debugMode}>
                    <div className="flex-grow">Current Season:</div> {season}
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    <Dropdown.Item as="button" type="button" onClick={() => saveSeason("Fall")}>Fall</Dropdown.Item>
                    <Dropdown.Item as="button" type="button" onClick={() => saveSeason("Winter")}>Winter</Dropdown.Item>
                    <Dropdown.Item as="button" type="button" onClick={() => saveSeason("Spring")}>Spring</Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
              <hr className="padded-hr" />
              <div className="flex flex-row flex-gap">
                <Button className="ventris-button-secondary ventris-button-secondary-teal flex-grow" onClick={cancelAndExitTest}>Cancel & Exit Test</Button>
                <Button className={selectedSubtests.length === 0 || !testAdministrationDate || !season ? "ventris-button-primary ventris-button-primary-disabled flex-grow" : "ventris-button-primary ventris-button-primary-teal flex-grow"} onClick={() => { setShownSubtestSelection(true); saveSelectedSubtests(); }}>Continue to Instructions</Button>
              </div>
              <div className="center wra-fsu-acknowledgement">
                Certain copyrighted materials herein are licensed from the Florida State University Florida Center for Reading Research with support from the Chan Zuckerberg Initiative DAF. Copyright 2022 Florida State University
              </div>
              <br />
            </Card> : null }
            {test.status !== "Complete" && selectedSubtest && !shownInstructionsForSubtest && showBeginSubtestButton ?
            <Card className="content-card" key={cardKey}>
              <div className="flex flex-row">
                <div className="flex-grow">
                  <Link to="/"><img src={logo} alt="Ventris Learning Logo" className="ventris-header-logo-wra" /></Link>
                </div>
                <div className="test-header-student-name">
                  {studentName}
                </div>
                {renderExaminerHeaderTitle(selectedSubtest)}
                <img src={wra} alt="WRA Logo" className="wra-logo" />
              </div>
              <hr />
              <div className="subtest-name-interstitial center">Next Subtest: {selectedSubtest}</div>
              <hr className="padded-hr" />
              <div className="flex flex-row flex-gap">
                <Button className="ventris-button-secondary ventris-button-secondary-teal flex-grow" onClick={cancelAndExitTest}>Cancel & Exit Test</Button>
                <Button className="ventris-button-primary ventris-button-primary-teal flex-grow" onClick={() => { setShowBeginSubtestButton(false); }}>Show Instructions & Begin Subtest</Button>
              </div>
              <br />
            </Card> : null }
            {test.status !== "Complete" && selectedSubtest && !shownInstructionsForSubtest && !showBeginSubtestButton ?
            <Card className="content-card" key={cardKey}>
              <div className="flex flex-row">
                <div className="flex-grow">
                  <Link to="/"><img src={logo} alt="Ventris Learning Logo" className="ventris-header-logo-wra" /></Link>
                </div>
                <div className="test-header-student-name">
                  {studentName}
                </div>
                {renderExaminerHeaderTitle(selectedSubtest)}
                <img src={wra} alt="WRA Logo" className="wra-logo" />
              </div>
              <hr />
              <div className="test-instructions center">{selectedSubtest}</div>
              <h3 className="test-header center">Instructions</h3>
              <div className="center">First, play the following instruction audio files in order.</div>
              <div className="subtest-selection-wrapper flex flex-column flex-gap">
                <div className="test-instructions center">AUDIO FILE 1</div>
                <Button aria-label={`Play ${selectedSubtest} instruction audio 1`} disabled={!studentRealtimeReady} className={!studentRealtimeReady ? "ventris-button-primary ventris-button-primary-disabled full-width" : "ventris-button-primary ventris-button-primary-teal full-width"} onClick={() => playNextAudioInstruction(1)}>Play Audio</Button>
                {instructionCountForSubtest(selectedSubtest) > 1 ?
                <>
                  <div className={playedInstructionCount < 1 ? "test-instructions-disabled center" : "test-instructions center"}>AUDIO FILE 2</div>
                  <Button aria-label={`Play ${selectedSubtest} instruction audio 2`} disabled={playedInstructionCount < 1 || !studentRealtimeReady} className={playedInstructionCount < 1 || !studentRealtimeReady ? "ventris-button-primary ventris-button-primary-disabled full-width" : "ventris-button-primary ventris-button-primary-teal full-width"} onClick={() => playNextAudioInstruction(2)}>Play Audio</Button>
                </> : null }
                {playedInstructionCount > 1 && selectedSubtest === "Nonword Reading" ?
                <div>
                  <img src={ventrisConfig.url + '/assets/wra/nonword-reading/items/nre_d_2.png'} alt="zuk" className="full-width" />
                </div> : null }
                {instructionCountForSubtest(selectedSubtest) > 2 ?
                <>
                  <div className={playedInstructionCount < 2 ? "test-instructions-disabled center" : "test-instructions center"}>AUDIO FILE 3</div>
                  <Button aria-label={`Play ${selectedSubtest} instruction audio 3`} disabled={playedInstructionCount < 2 || !studentRealtimeReady} className={playedInstructionCount < 2 || !studentRealtimeReady ? "ventris-button-primary ventris-button-primary-disabled full-width" : "ventris-button-primary ventris-button-primary-teal full-width"} onClick={() => playNextAudioInstruction(3)}>Play Audio</Button>
                </> : null }
              </div>
              <br />
              <hr className="padded-hr" />
              <div className="flex flex-row flex-gap">
                <Button className="ventris-button-secondary ventris-button-secondary-teal flex-grow" onClick={cancelAndExitTest}>Cancel & Exit Test</Button>
                <Button className={playedInstructionCount < instructionCountForSubtest(selectedSubtest) ? "ventris-button-primary ventris-button-primary-disabled flex-grow" : "ventris-button-primary ventris-button-primary-teal flex-grow"} onClick={() => { setShownInstructionsForSubtest(true); setCurrentQuestionStep(1); }}>Continue to Example 1</Button>
              </div>
              <br />
            </Card> : null }
            {test.status !== "Complete" && selectedSubtest && shownInstructionsForSubtest && !shownExamplesForSubtest ?
            <Card className="content-card" key={cardKey}>
              <div className="flex flex-row">
                <div className="flex-grow">
                  <Link to="/"><img src={logo} alt="Ventris Learning Logo" className="ventris-header-logo-wra" /></Link>
                </div>
                <div className="test-header-student-name">
                  {studentName}
                </div>
                {renderExaminerHeaderTitle(selectedSubtest)}
                <img src={wra} alt="WRA Logo" className="wra-logo" />
              </div>
              <hr />
              <div className="test-instructions center">{selectedSubtest}</div>
              <h3 className="test-header center">Example {(shownExampleCount + 1)}</h3>
              <div className="center">Next, {selectedSubtest == "Blending" || selectedSubtest == "Deletion" ? "play the audio file" : "show the image"} for the example word and record the student's reponse.</div>
              <div>
                {selectedSubtest == "Blending" ?
                <div className="flex flex-column center">
                  <div className="center test-instructions">STEP 1: CLICK PLAY AUDIO</div>
                  <Button aria-label={`${currentQuestionStep > 1 ? "Replay" : "Play"} ${selectedSubtest} example ${shownExampleCount + 1} audio`} disabled={!studentRealtimeReady} className={!studentRealtimeReady ? "ventris-button-primary ventris-button-primary-disabled test-asset-button" : "ventris-button-primary ventris-button-primary-teal test-asset-button"} onClick={() => playAudio(selectedSubtest, getExampleQuestion(selectedSubtest, shownExampleCount).item_name)}>{currentQuestionStep > 1 ? "Replay Audio" : "Play Audio"}</Button>
                  <div className={currentQuestionStep > 1 ? "test-prompt" : "test-prompt-disabled"} dangerouslySetInnerHTML={{__html: getExampleQuestion(selectedSubtest, shownExampleCount).question}}></div>
                  <div className={currentQuestionStep > 1 ? "test-prompt" : "test-prompt-disabled"} dangerouslySetInnerHTML={{__html: '[' + getExampleQuestion(selectedSubtest, shownExampleCount).answer + ']'}}></div>
                </div> : null }
                {selectedSubtest == "Deletion" ?
                <>
                  <div className="flex flex-column center">
                    <div className="center test-instructions">STEP 1: CLICK PLAY AUDIO</div>
                    <Button aria-label={`${currentQuestionStep > 1 ? "Replay" : "Play"} ${selectedSubtest} example ${shownExampleCount + 1} audio part 1`} disabled={!studentRealtimeReady} className={!studentRealtimeReady ? "ventris-button-primary ventris-button-primary-disabled test-asset-button" : "ventris-button-primary ventris-button-primary-teal test-asset-button"} onClick={() => playAudio(selectedSubtest, getExampleQuestion(selectedSubtest, shownExampleCount).item_name)}>{currentQuestionStep > 1 ? "Replay Audio" : "Play Audio"}</Button>
                  </div>
                  <div className="flex flex-column center">
                    <div className="center test-instructions">STEP 2: CLICK PLAY AUDIO</div>
                    <Button aria-label={`${currentQuestionStep > 2 ? "Replay" : "Play"} ${selectedSubtest} example ${shownExampleCount + 1} audio part 2`} disabled={currentQuestionStep < 2 || !studentRealtimeReady} className={currentQuestionStep < 2 || !studentRealtimeReady ? "ventris-button-primary ventris-button-primary-disabled test-asset-button" : "ventris-button-primary ventris-button-primary-teal test-asset-button"} onClick={() => {if (playAudio(selectedSubtest, getExampleQuestion(selectedSubtest, shownExampleCount).item_name_2!)) { setCurrentQuestionStep(3); }}}>{currentQuestionStep > 2 ? "Replay Audio" : "Play Audio"}</Button>
                    <div className={currentQuestionStep > 2 ? "test-prompt" : "test-prompt-disabled"} dangerouslySetInnerHTML={{__html: getExampleQuestion(selectedSubtest, shownExampleCount).question}}></div>
                    <div className={currentQuestionStep > 2 ? "test-prompt" : "test-prompt-disabled"} dangerouslySetInnerHTML={{__html: '[' + getExampleQuestion(selectedSubtest, shownExampleCount).answer + ']'}}></div>
                  </div>
                </> : null }
                {selectedSubtest == "Nonword Reading" || selectedSubtest == "Word Reading" ?
                <div className="flex flex-column center">
                  <div className="center test-instructions">STEP 1: CLICK SHOW WORD</div>
                  <Button disabled={!studentRealtimeReady} className={!studentRealtimeReady ? "ventris-button-primary ventris-button-primary-disabled test-asset-button" : "ventris-button-primary ventris-button-primary-teal test-asset-button"} onClick={() => {if (showWord(selectedSubtest, getExampleQuestion(selectedSubtest, shownExampleCount).question)) { playAudio(selectedSubtest, getExampleQuestion(selectedSubtest, shownExampleCount).item_name); }}}>Show Word</Button>
                  <div className={currentQuestionStep > 1 ? "test-prompt" : "test-prompt-disabled"} dangerouslySetInnerHTML={{__html: getExampleQuestion(selectedSubtest, shownExampleCount).question}}></div>
                  {selectedSubtest !== "Word Reading" ?
                  <div className="pronunciation-guidance-row">
                    <div className={currentQuestionStep > 1 ? "test-prompt" : "test-prompt-disabled"} dangerouslySetInnerHTML={{__html: '[' + getExampleAnswerCaption(selectedSubtest, shownExampleCount) + ']'}}></div>
                    {currentQuestionStep > 1 ?
                    <PronunciationGuidance
                      itemName={getExampleQuestion(selectedSubtest, shownExampleCount).item_name}
                      ipa={(getExampleQuestion(selectedSubtest, shownExampleCount) as any).ipa_pronunciation}
                      phonics={(getExampleQuestion(selectedSubtest, shownExampleCount) as any).phonics_pronunciation}
                    /> : null}
                  </div> : null}
                </div> : null }
                {selectedSubtest == "Deletion" ?
                <>
                  <div className={currentQuestionStep > 2 ? "test-instructions center" : "test-instructions-disabled center"}>STEP 3: RECORD STUDENT RESPONSE</div>
                  <fieldset className="wra-response-group">
                    <legend className="visually-hidden">Record student response</legend>
                    <div className={currentQuestionStep > 2 ? "flex flex-row flex-gap" : "flex flex-row flex-gap test-step-disabled"}>
                      <label className={currentQuestionCorrect === false ? "test-checkbox-incorrect-selected" : ((currentQuestionStep > 2 && currentQuestionCorrect !== true) ? "test-checkbox-incorrect" : "test-checkbox-disabled")}>
                        <input type="radio" name="wra-example-response" checked={currentQuestionCorrect === false} disabled={currentQuestionStep <= 2} onChange={() => {showWord(selectedSubtest, ""); setCurrentQuestionCorrect(false); playAudio(selectedSubtest, getExampleQuestion(selectedSubtest, shownExampleCount).incorrect); }} />
                        Incorrect Answer
                      </label>
                      <label className={currentQuestionCorrect === true ? "test-checkbox-correct-selected" : ((currentQuestionStep > 2 && currentQuestionCorrect !== false) ? "test-checkbox-correct" : "test-checkbox-disabled")}>
                        <input type="radio" name="wra-example-response" checked={currentQuestionCorrect === true} disabled={currentQuestionStep <= 2} onChange={() => {showWord(selectedSubtest, ""); setCurrentQuestionCorrect(true); playAudio(selectedSubtest, getExampleQuestion(selectedSubtest, shownExampleCount).correct);}} />
                        Correct Answer
                      </label>
                    </div>
                  </fieldset>
                </> :
                <>
                  <div className={currentQuestionStep > 1 ? "test-instructions center" : "test-instructions-disabled center"}>STEP 2: RECORD STUDENT RESPONSE</div>
                  <fieldset className="wra-response-group">
                    <legend className="visually-hidden">Record student response</legend>
                    <div className={currentQuestionStep > 1 ? "flex flex-row flex-gap" : "flex flex-row flex-gap test-step-disabled"}>
                      <label className={currentQuestionCorrect === false ? "test-checkbox-incorrect-selected" : ((currentQuestionStep > 1 && currentQuestionCorrect !== true) ? "test-checkbox-incorrect" : "test-checkbox-disabled")}>
                        <input type="radio" name="wra-example-response" checked={currentQuestionCorrect === false} disabled={currentQuestionStep <= 1} onChange={() => {showWord(selectedSubtest, ""); setCurrentQuestionCorrect(false); playAudio(selectedSubtest, getExampleQuestion(selectedSubtest, shownExampleCount).incorrect); }} />
                        Incorrect Answer
                      </label>
                      <label className={currentQuestionCorrect === true ? "test-checkbox-correct-selected" : ((currentQuestionStep > 1 && currentQuestionCorrect !== false) ? "test-checkbox-correct" : "test-checkbox-disabled")}>
                        <input type="radio" name="wra-example-response" checked={currentQuestionCorrect === true} disabled={currentQuestionStep <= 1} onChange={() => {showWord(selectedSubtest, ""); setCurrentQuestionCorrect(true); playAudio(selectedSubtest, getExampleQuestion(selectedSubtest, shownExampleCount).correct);}} />
                        Correct Answer
                      </label>
                    </div>
                  </fieldset>
                </> }
                
                <hr className="padded-hr" />
                <div className="flex flex-row flex-gap">
                  <Button className="ventris-button-secondary ventris-button-secondary-teal flex-grow" onClick={cancelAndExitTest}>Cancel & Exit Test</Button>
                  <Button className={currentQuestionCorrect === null ? "ventris-button-primary ventris-button-primary-disabled flex-grow" : "ventris-button-primary ventris-button-primary-teal flex-grow"} onClick={() => {if (getExampleQuestion(selectedSubtest, shownExampleCount).submission) { playAudio(selectedSubtest, getExampleQuestion(selectedSubtest, shownExampleCount).submission!); } updateShownExampleCount();}}>{shownExampleCount == 0 ? "Continue to Example 2" : ("Begin " + selectedSubtest + " Subtest")}</Button>
                </div>
                <br />
              </div>
            </Card> : null }
            {test.status !== "Complete" && selectedSubtest && shownInstructionsForSubtest && shownExamplesForSubtest ?
            <Card className="content-card" key={cardKey}>
              <div className="flex flex-row">
                <div className="flex-grow">
                  <Link to="/"><img src={logo} alt="Ventris Learning Logo" className="ventris-header-logo-wra" /></Link>
                </div>
                <div className="test-header-student-name">
                  {studentName}
                </div>
                {renderExaminerHeaderTitle(selectedSubtest)}
                <img src={wra} alt="WRA Logo" className="wra-logo" />
              </div>
              <hr />
              {showWraProgressBars ? <div className="flex flex-row flex-gap">
                {showSubtest("Blending") ?
                <div className={progressForSubtest("Blending") > 0 ? "subtest-progress flex-grow" : "subtest-progress-disabled flex-grow"}>
                  <div className={"subtest-progress-inner-" + progressForSubtest("Blending")}></div>
                </div> : null}
                {showSubtest("Deletion") ?
                <div className={progressForSubtest("Deletion") > 0 ? "subtest-progress flex-grow" : "subtest-progress-disabled flex-grow"}>
                  <div className={"subtest-progress-inner-" + progressForSubtest("Deletion")}></div>
                </div> : null}
                {showSubtest("Nonword Reading") ?
                <div className={progressForSubtest("Nonword Reading") > 0 ? "subtest-progress flex-grow" : "subtest-progress-disabled flex-grow"}>
                  <div className={"subtest-progress-inner-" + progressForSubtest("Nonword Reading")}></div>
                </div> : null}
                {showSubtest("Word Reading") ?
                <div className={progressForSubtest("Word Reading") > 0 ? "subtest-progress flex-grow" : "subtest-progress-disabled flex-grow"}>
                  <div className={"subtest-progress-inner-" + progressForSubtest("Word Reading")}></div>
                </div> : null}
              </div> : null}
              {reorderingQuestions ?
              <div className="center">
                <br /><br /><br /><br /><br />
                <span role="status">
                  <Spinner animation="border" variant="secondary" />
                  <span className="visually-hidden">Preparing the next questions.</span>
                </span>
                <br /><br /><br />
                {selectedSubtest in scores ?
                <div className={debugMode ? "test-category-statistics" : "test-category-statistics hidden"}>
                  Max Theta: {scores[selectedSubtest].maxTheta}<br />
                  Max Theta Likelihood: {scores[selectedSubtest].maxThetaLikelihood}<br />
                  Standard Error: {scores[selectedSubtest].standardError}
                </div> : null }
                <br /><br /><br /><br /><br />
              </div> :
              <>
              {categories.map((category: any) => 
                <>
                  {category.name === selectedSubtest ?
                  <>
                    {category.name in scores ?
                    <div className={debugMode ? "test-category-statistics" : "test-category-statistics hidden"}>
                      Max Theta: {scores[category.name].maxTheta}<br />
                      Max Theta Likelihood: {scores[category.name].maxThetaLikelihood}<br />
                      Standard Error: {scores[category.name].standardError}
                    </div> : null }
                    {category.subcategories?.map((subcategory: any, subcategoryIndex: number) =>
                      <>
                        {showSection(category.name, subcategoryIndex) ?
                        <>
                          {debugMode ?
                          <div className="mb-3">
                            <Form.Select
                              aria-label="Debug question selector"
                              value={selectedDebugQuestionId ?? ""}
                              onChange={(event) => {
                                const value = event.target.value;
                                setSelectedDebugQuestionId(value === "" ? null : Number(value));
                              }}
                            >
                              <option value="">Select a question...</option>
                              {[...(subcategory.questions ?? [])]
                                .sort((a: any, b: any) => (a.question ?? "").localeCompare(b.question ?? ""))
                                .map((question: any) => (
                                <option key={question.id} value={question.id}>
                                  {question.question}
                                </option>
                              ))}
                            </Form.Select>
                          </div> : null }
                          {subcategory.questions?.map((question: any, questionIndex: number) => 
                            <>
                              {showQuestion(subcategory.name, question, questionIndex) ?
                              <div>
                                {category.name === "Blending" || category.name === "Deletion" ?
                                <div className="flex flex-column center">
                                  <div className="center test-instructions">STEP 1: CLICK PLAY AUDIO</div>
                                  <Button aria-label={`${currentQuestionStep > 1 ? "Replay" : "Play"} ${category.name} item audio`} disabled={!studentRealtimeReady} className={!studentRealtimeReady ? "ventris-button-primary ventris-button-primary-disabled test-asset-button" : "ventris-button-primary ventris-button-primary-teal test-asset-button"} onClick={() => playAudio(category.name, question.item_name)}>{currentQuestionStep > 1 ? "Replay Audio" : "Play Audio"}</Button>
                                  <div className={currentQuestionStep > 1 ? "test-prompt" : "test-prompt-disabled"} dangerouslySetInnerHTML={{__html: question.question}}></div>
                                  <div className={currentQuestionStep > 1 ? "test-prompt" : "test-prompt-disabled"} dangerouslySetInnerHTML={{__html: '[' + question.answers[0].answer + ']'}}></div>
                                </div> : null }
                                {category.name === "Nonword Reading" || category.name === "Word Reading" ?
                                <div className="flex flex-column center">
                                  <div className="center test-instructions">STEP 1: CLICK SHOW WORD</div>
                                  <Button disabled={!studentRealtimeReady} className={!studentRealtimeReady ? "ventris-button-primary ventris-button-primary-disabled test-asset-button" : "ventris-button-primary ventris-button-primary-teal test-asset-button"} onClick={() => showWord(category.name, question.question)}>Show Word</Button>
                                  <div className={currentQuestionStep > 1 ? "test-prompt" : "test-prompt-disabled"} dangerouslySetInnerHTML={{__html: question.question}}></div>
                                  {category.name !== "Word Reading" ?
                                  <div className="pronunciation-guidance-row">
                                    <div className={currentQuestionStep > 1 ? "test-prompt" : "test-prompt-disabled"} dangerouslySetInnerHTML={{__html: '[' + getCorrectAnswerCaption(question) + ']'}}></div>
                                    {currentQuestionStep > 1 ?
                                    <PronunciationGuidance
                                      itemName={question.item_name}
                                      ipa={question.ipa_pronunciation}
                                      phonics={question.phonics_pronunciation}
                                    /> : null}
                                  </div> : null}
                                </div> : null }
                                <div className={debugMode ? "center" : "center hidden"}>
                                  <br />
                                  Discrimination: {question.discrimination ? question.discrimination : 'N/A'}, Difficulty: {question.difficulty ? question.difficulty : 'N/A'}
                                  <br />
                                </div>
                                <div className={currentQuestionStep > 1 ? "test-instructions center" : "test-instructions-disabled center"}>STEP 2: RECORD STUDENT RESPONSE</div>
                                <fieldset className="wra-response-group">
                                  <legend className="visually-hidden">Record student response</legend>
                                  <div className={currentQuestionStep > 1 ? "flex flex-row flex-gap" : "flex flex-row flex-gap test-step-disabled"}>
                                    <label className={currentQuestionCorrect === false ? "test-checkbox-incorrect-selected" : ((currentQuestionStep > 1 && currentQuestionCorrect !== true) ? "test-checkbox-incorrect" : "test-checkbox-disabled")}>
                                      <input type="radio" name="wra-question-response" checked={currentQuestionCorrect === false} disabled={currentQuestionStep <= 1} onChange={() => {showWord(category.name, ""); setCurrentQuestionCorrect(false);}} />
                                      Incorrect Answer
                                    </label>
                                    <label className={currentQuestionCorrect === true ? "test-checkbox-correct-selected" : ((currentQuestionStep > 1 && currentQuestionCorrect !== false) ? "test-checkbox-correct" : "test-checkbox-disabled")}>
                                      <input type="radio" name="wra-question-response" checked={currentQuestionCorrect === true} disabled={currentQuestionStep <= 1} onChange={() => {showWord(category.name, ""); setCurrentQuestionCorrect(true);}} />
                                      Correct Answer
                                    </label>
                                  </div>
                                </fieldset>
                                <div className={currentQuestionStep > 1 ? "test-response-instructions hidden" : "test-response-instructions-disabled hidden"}>
                                  RESPONSE NOTES
                                </div>
                                <Form.Control as="textarea" rows={3} placeholder="Enter Notes (Optional)" className={currentQuestionStep > 1 ? "test-answer-notes hidden" : "test-answer-notes-disabled hidden"} defaultValue={textAnswers[question.id]} onChange={(event) => updateTextAnswer(question, event.target.value)} />
                                <hr className="padded-hr" />
                                <div className="flex flex-row flex-gap">
                                  <Button className="ventris-button-secondary ventris-button-secondary-teal flex-grow" onClick={cancelAndExitTest}>Cancel & Exit Test</Button>
                                  <Button className={currentQuestionCorrect === null ? "ventris-button-primary ventris-button-primary-disabled flex-grow" : "ventris-button-primary ventris-button-primary-teal flex-grow"} onClick={() => answerQuestion(question, question.answers[currentQuestionCorrect ? 0 : 1], answers[question.id] == question.answers[currentQuestionCorrect ? 0 : 1].id)}>Next Question</Button>
                                </div>
                                <br />
                              </div> : null }
                            </>
                          )}
                        </> : null }
                      </>
                    )}
                  </> : null }
                </>
              )}
              </> }
            </Card> : null }
            {test.status === "Complete" ?
            <Card className="content-card" key={cardKey}>
              <div className="flex flex-row">
                <div className="flex-grow">
                  <Link to="/"><img src={logo} alt="Ventris Learning Logo" className="ventris-header-logo-wra" /></Link>
                </div>
                <div className="test-header-student-name">
                  {studentName}
                </div>
                {renderExaminerHeaderTitle("Select Subtests")}
                <img src={wra} alt="WRA Logo" className="wra-logo" />
              </div>
              <hr />
              This test has been completed! Completion Date: {test.completed_timestamp?.split(' ')[0]}
              <br /><br />
              <Table bordered>
                <thead>
                  <tr>
                    <th className="td-center">Correct Answers</th>
                    <th className="td-center">Incorrect Answers</th>
                    <th className="td-center">Blank Answers</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="td-center">{correctAnswers}</td>
                    <td className="td-center">{incorrectAnswers}</td>
                    <td className="td-center">{blankAnswers}</td>
                  </tr>
                </tbody>
              </Table>
              <br />
              <Table bordered>
                <thead>
                  <tr>
                    <th>Subtest</th>
                    <th>Raw Score</th>
                  </tr>
                </thead>
                <tbody>
                  {categories.map((category: any) => 
                    <tr>
                      <td>{category.name}</td>
                      <td>{domains[category.name] ? domains[category.name].score : 0}</td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </Card> : null }
            {role === "Examiner" && currentUser?.organization_id === 1 ?
              <div className="d-flex justify-content-center mt-3">
                <Form.Check
                  type="checkbox"
                  id="wra-debug-mode"
                  label={<span className="fw-bold">Debug Mode</span>}
                  checked={debugMode}
                  onChange={(event) => setDebugMode(event.target.checked)}
                />
              </div> : null }
            <br /><br />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default TestWRA;
